import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { useGlobalContext } from "../../../Config";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import {calculateSubtotal,formatDatesIfNeeded,calculateTarifaMensualWithMetraje,calculateTarifaMensualServicios,calculateTarifaMensualServiciosUnicos,sortDataByProductAndSubProduct,} from "../../../utilities/Helper";
import { ejecutarCierreContrato } from "../../../utilities/cerrarContratoUtils";
import moment from "moment";
import "moment/locale/es";
import CotizacionActions from "../components/CotizacionActions";
import FormCrearCliente from "../../client/components/FormCrearCliente";
import ResumenMensualDialog from "../components/ResumenMensualDialog";
import RenovarAsignacionDialog from "../../assignment/components/RenovarAsignacionDialog";
import ArriendoDataTable from "../components/ArriendoDataTable";
import ServiciosDataTable from "../components/ServiciosDataTable";
import ServiciosUnicosDataTable from "../components/ServiciosUnicosDataTable";
import FormAgregarSubproductoCotizacion from "../components/FormAgregarSubproductoCotizacion";
import {
  getCotizacionById,
  actualizarDetalleCotizacion,
  updateCotizacion,
  getInformacionFaltanteByIdCliente,
  recotizar,
  getServiciosByIdEmpresa,
  sincronizarDetallesCotizacion,
  validarElementosActivosCotizacion,
} from "../../../services/CotizacionService.js";
import { getConfiguracionPredeterminada, getConfiguracionDocumentos } from "../../../services/ClienteService.js";
import useTiposDocumento from "../../../shared/hooks/useTiposDocumento.js";
import {
  buildActualizarDetalleParams,
  toSyncItem,
} from "../utils/detallePayload.js";
import { desasociarSubproductosAdicionales, esSubproductoAdicional } from "../utils/asociacionSubproductos.js";
import useDatosCotizacion from "../hooks/useDatosCotizacion.js";
import exportarCotizacionAPdf from "../utils/exportarCotizacionPdf";

const cantidadDiasAvisoContrato = [{ label: "15 días", value: 15 },{ label: "30 días", value: 30 },{ label: "45 días", value: 45 },{ label: "60 días (recomendado)", value: 60 },{ label: "90 días", value: 90 },];
const cantidadDiasFirmaContrato = [ { label: "5 días (rápido)", value: 5 }, { label: "15 días (recomendado)", value: 15 }, { label: "30 días", value: 30 }, { label: "45 días", value: 45 }, { label: "60 días", value: 60 }, { label: "90 días", value: 90 },];

const dateFormats = ["DD/MM/YYYY","MM/DD/YYYY","YYYY/MM/DD","YYYY-MM-DD","DD-MM-YYYY","MM-DD-YYYY","DD MMM YYYY","MMM DD, YYYY","MMMM DD, YYYY","YYYY MMM DD",];

/**
 * Convierte una fecha en formato válido "YYYY-MM-DD".
 * @param {string|Date} dateInput - Fecha de entrada.
 * @return {string|null} Fecha formateada o null si es inválida.
 */
const formatDateTramoSilencioso = (dateInput) => {
  const formattedDate = moment(dateInput, dateFormats, true);
  return formattedDate.isValid() ? formattedDate.format("YYYY-MM-DD") : null;
};

const RevisarCotizacion = (props) => {
  const { baseUrl, urlContratos } = useGlobalContext();
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const [carro, setCarro] = useState([]); // Almacena los elementos seleccionados en el carrito

  const {
    cotizacion,
    cliente,
    detallesCobro,
    setDetallesCobro,
    monedaOptions,
    monedaOptionsFetched,
    selectedItemsParam,
    getDetalleData,
    fetchDataCliente,
  } = useDatosCotizacion(baseUrl, idCliente, idCotizacion);

  const [diasAviso, setDiasAviso] = useState(60);// Estado para el número de días de aviso antes de cerrar el contrato
  const [diasFirma, setDiasFirma] = useState(15);// Estado para el número de días de firma del contrato

  const [subtotalServicios, setSubtotalServicios] = useState(0); // Estado para almacenar el subtotal de servicios en la cotización
  const [showCerrarContrato, setShowCerrarContrato] = useState(false);
  // Configuración predeterminada de documentos de venta del cliente (para el diálogo de cierre)
  const [configuracionPredeterminada, setConfiguracionPredeterminada] = useState(null);
  // Asignaciones vigentes/futuras del cliente con su configuración de
  // documentos por ítem (para el diálogo de cierre)
  const [asignacionesVigentesFuturas, setAsignacionesVigentesFuturas] = useState([]);

  const [desde, setDesde] = useState(searchParams.get("desde")); // Extrae las fechas "desde" y "hasta" de la URL
  const [hasta, setHasta] = useState(searchParams.get("hasta"));
  const [loading, setLoading] = useState(false); // Estado para manejar la carga de datos
  const guardandoRef = useRef(false); // Guarda síncrona contra doble envío
  const [loadingAsig, setLoadingAsig] = useState(false); // Estado para manejar la carga de datos
  const [exportandoPdf, setExportandoPdf] = useState(false); // Estado para la generación del PDF
  const [flattenedDataArriendo, setFlattenedDataArriendo] = useState([]); // Datos de arriendo en un formato aplanado
  const [serviciosUnicos, setServiciosUnicos] = useState([]); // Lista de servicios únicos en la cotización
  const [tramoCounter, setTramoCounter] = useState(0);  // Estado para contar el número de tramos en la cotización
  const [itemsPorEliminar] = useState([]);
  const [maxAmountOfCuotas, setMaxAmountOfCuotas] = useState(0);  // Estado para manejar el número máximo de cuotas permitidas
  const [cuotas, setCuotas] = useState(0);// Estado para manejar la cantidad de cuotas seleccionadas
  const [itemCuotas, setItemCuotas] = useState(null);// Estado para almacenar los ítems asociados a cuotas
  const [showTramoModalArriendo, setShowTramoModalArriendo] = useState(false);// Estado para mostrar el modal de tramo de arriendo
  const toast = useRef(null);
  const [showDialog, setShowDialog] = useState(false);
  const [empresas] = useState([{ name: "TODAS", value: "TODAS" },{ name: "ALTAMIRA", value: "Altamira" },{ name: "LA SIEMBRA", value: "LA SIEMBRA" },]);
  const [showProductForm2, setshowProductForm2] = useState(false);
  const [showSubproductoDialog, setShowSubproductoDialog] = useState(false);
  const [showRechazarDialog, setShowRechazarDialog] = useState(false);
  const [showVencimientoDialog, setShowVencimientoDialog] = useState(false);
  const [showRenovarDialog, setShowRenovarDialog] = useState(false);
  const [observacion, setObservacion] = useState("");
  const motivosRechazo = [{ label: "especificación tecnica", value: "especificacion tecnica" },{ label: "fidelización comercial", value: "fidelizacion comercial" },{ label: "fidelización logistica", value: "fidelizacion logistica" },{ label: "linea de credito", value: "linea de credito" },{ label: "plazo de entrega", value: "plazo de entrega" },{ label: "plazo de pago", value: "plazo de pago" },{ label: "precio(s)", value: "precio(s)" },{ label: "servicios", value: "servicios" },{ label: "stock disponible", value: "stock disponible" },{ label: "obra detenida", value: "obra detenida" }];
  const motivosRenovacion = [{ label: "Buen cumplimiento", value: "Buen cumplimiento" },{ label: "Continuidad de uso", value: "Continuidad de uso" },{ label: "Conveniencia mutua", value: "conveniencia mutua" },{ label: "Mismo acuerdo previo", value: "Mismo acuerdo previo" },{ label: "Ajuste por IPC", value: "Ajuste por IPC" },{ label: "Buena relación", value: "Buena relación" },{ label: "Sin cambio de uso", value: "Sin cambio de uso" },{ label: "Por solicitud del arrendatario", value: "Por solicitud del arrendatario" },{ label: "Mantener arrendatario", value: "Mantener arrendatario" },{ label: "Extensión temporal", value: "Extensión temporal" }];
  const [fechaVencimiento, setFechaVencimiento] = useState(null);
  const [hastaRenovacion, setHastaRenovacion] = useState(null);
  useEffect(() => {
      if (hasta && !hastaRenovacion) {
          const primerDisponible = moment(hasta, "YYYY-MM-DD", true).add(1, "day").startOf("day").toDate();
          setHastaRenovacion(primerDisponible);
      }
  }, [hasta, hastaRenovacion]);

  // Re-cargar fechas cuando cambien los parámetros de la URL
  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const newDesde = sp.get("desde");
    const newHasta = sp.get("hasta");

    if (typeof newDesde !== "undefined") setDesde(newDesde);
    if (typeof newHasta !== "undefined") setHasta(newHasta);
  }, [location.search]);
  const navigate = useNavigate();

  useEffect(() => {
    const estado = String(cotizacion?.estado?.estado || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

    if (estado !== "COTIZACION") {
      return;
    }

    const onPopState = () => {
      navigate("/cotizacion", { replace: true });
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [cotizacion, navigate]);

  const [showTramoModalServicio, setShowTramoModalServicio] = useState(false);
  const [showTramoModalUnico, setShowTramoModalUnico] = useState(false);
  const handleNewTramoCuota = (rowData) => {
    clearTramosVariables();
    if (rowData.tarifa_cliente <= 0) {
      alert("Debe añadir una tarifa para poder elegir cuotas");
    } else {
      setNombreCuadro(rowData.descripcion);

      // Ensure the dates are in dd/mm/yyyy format
      const startDate = moment(desde, dateFormats, true);
      const endDate = moment(hasta, dateFormats, true);

      if (!startDate.isValid() || !endDate.isValid()) {
        alert("Fechas no válidas");
        return;
      }

      const diffInMonths = endDate.diff(startDate, "months");

      // Set maxAmountOfCuotas with the number of months
      setMaxAmountOfCuotas(diffInMonths + 1);
      setShowTramoModalUnico(true);
      setCuotas(0);
      setItemCuotas(rowData);
    }
  };
  const handleNewTramoServicio = (rowData) => {
    clearTramosVariables();
    setNombreCuadro(rowData.descripcion);

    // Parse dates using moment
    const desdeDate = moment(rowData.desde, dateFormats, true).toDate();
    const hastaDate = moment(rowData.hasta, dateFormats, true).toDate();

    if (
      !moment(rowData.desde, dateFormats, true).isValid() ||
      !moment(rowData.hasta, dateFormats, true).isValid()
    ) {
      alert("Fechas no válidas");
      return;
    }

    const tramo1 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };
    const tramo2 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };

    // No need to adjust for timezone offset since moment handles it properly

    setHastaTramoGeneral(hastaDate);
    setTramos([tramo1, tramo2]);

    setShowTramoModalServicio(true);
  };
  const [servicios, setServicios] = useState([]);
  const [subtotalArriendo, setSubtotalArriendo] = useState(0);

    
  // --------------------------------------
  // Efectos de las modificaciones de items 
  // --------------------------------------
  useEffect(() => {
    if (selectedItemsParam) {
      try {
        const decodedParam = decodeURIComponent(selectedItemsParam);

        if (decodedParam.startsWith("[")) {
          const selectedItems = JSON.parse(decodedParam);
          setCarro(selectedItems);
        } else {
          const selectedItems = JSON.parse(`[${decodedParam}]`);

          setCarro(selectedItems);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [selectedItemsParam]);

  useEffect(() => {
    if (carro.length > 0) {
      // Se crean arreglos vacíos para almacenar los diferentes tipos de elementos dentro de "carro"
      const serviciosInside = []; // Almacena servicios que no son "Habilitacion Fibra" ni "Obra Civil"
      const subproductosInside = []; // Almacena subproductos
      const serviciosUnicosInside = []; // Almacena servicios únicos como "Habilitacion Fibra" u "Obra Civil"
      const flattenedDataArriendoInside = []; // Almacena productos de tipo "arriendo"

      // Se recorre el array "carro" para clasificar los elementos según su tipo de relación
      carro.forEach((item) => {
        if (item.relacion === "subproducto") {
          subproductosInside.push(item); // Agrega los subproductos al array correspondiente
        } else if (item.relacion === "producto") {
          flattenedDataArriendoInside.push(item); // Agrega los productos de tipo arriendo
        } else if (item.relacion === "servicio") {
          // Se excluyen los servicios de "Habilitacion Fibra" y "Obra Civil"
          if ( !(item.descripcion.includes("Habilitacion Fibra") || item.descripcion.includes("Obra Civil"))){
            // Si el servicio es "Agua" o "Electricidad", se marca con la propiedad "remarcador"
            if (
              item.descripcion.includes("Agua") ||
              item.descripcion.includes("Electricidad")
            ) {
              item.remarcador = true;
              serviciosInside.push(item);
            } else {
              item.remarcador = false;
              serviciosInside.push(item);
            }
          } else {
            // Si es "Habilitacion Fibra" u "Obra Civil", se agrega a "serviciosUnicosInside"
            serviciosUnicosInside.push(item);
          }
        }
      });

      // Los subproductos se añaden al array de productos de arriendo
      subproductosInside.forEach((subprod) => {
        flattenedDataArriendoInside.push(subprod);
      });

      // Función para agrupar elementos por "descripcion"
      const groupByDescripcion = (arr) => {
        const groups = arr.reduce((acc, item) => {
          if (!acc[item.descripcion]) {
            acc[item.descripcion] = [];
          }
          acc[item.descripcion].push(item);
          return acc;
        }, {});

        return Object.values(groups); // Devuelve un array con los grupos formados
      };

      // Función para ordenar por fecha ascendente según la propiedad "desde"
      const sortByDate = (a, b) =>
        moment(a.desde, dateFormats, true).toDate() -
        moment(b.desde, dateFormats, true).toDate();

      // Función para ordenar los grupos por fecha y aplanar el array en una sola lista
      const mergeSortedGroups = (groups) => {
        return groups.map((group) => group.sort(sortByDate)).flat();
      };

      // Se separan y ordenan los servicios únicos agrupándolos por descripción y dividiendo en "splittable" y "unsplittable"
      const sortedServiciosUnicos = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(serviciosUnicosInside)),
        ...groupByDescripcion(splittable(serviciosUnicosInside)),
      ]);

      // Se ordenan los productos de arriendo aplicando la misma lógica
      const sortedFlattenedDataArriendo = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(flattenedDataArriendoInside)),
        ...groupByDescripcion(splittable(flattenedDataArriendoInside)),
      ]);

      const groupedArriendoData = sortedFlattenedDataArriendo;

      // Se ordenan los servicios normales aplicando la misma lógica
      const sortedServicios = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(serviciosInside)),
        ...groupByDescripcion(splittable(serviciosInside)),
      ]);

      const groupedServiciosData = sortedServicios;

      // Antes: let finalServiciosUnicos = sortDataByProductAndSubProduct(groupedServiciosUnicosData);
      let finalServiciosUnicos = sortDataByProductAndSubProduct(sortedServiciosUnicos);

      // Si existen elementos que correspondan a cuotas, se reordena numéricamente según el número extraído
      if (finalServiciosUnicos.some(item => item.tramo && item.tramo.toLowerCase().includes("cuota"))) {
        finalServiciosUnicos.sort((a, b) => {
          const extractCuotaNumber = (str) => {
            if (!str) return 0;
            const trimmedStr = str.trim();
            const regex = /Cuota\s+(\d+)/i;
            const match = trimmedStr.match(regex);
            return match ? parseInt(match[1], 10) : 0;
          };
          return extractCuotaNumber(a.tramo) - extractCuotaNumber(b.tramo);
        });
      }

      // Se actualizan los estados con los datos ordenados y agrupados correctamente
      setServiciosUnicos(sortDataByProductAndSubProduct(finalServiciosUnicos));
      setFlattenedDataArriendo(sortDataByProductAndSubProduct(groupedArriendoData));
      setServicios(sortDataByProductAndSubProduct(groupedServiciosData));

    }
  }, [carro]); // Se ejecuta cada vez que "carro" cambia

  // --------------------------------------
  // Manejo de tramos y cuotas
  // --------------------------------------
  const unsplittable = (arr) =>
    arr.filter((item) => !item.descripcion.includes(" - "));
  const splittable = (arr) =>
    arr.filter((item) => item.descripcion.includes(" - "));
  const [tramos, setTramos] = useState([]);
  const [nombreCuadro, setNombreCuadro] = useState("");
  const [hastaTramoGeneral, setHastaTramoGeneral] = useState(null);

  const handleTramoConfirmationArriendo = async (descripcion) => {
    if (loading) return;
    setLoading(true);

    const duplicateTramos = tramos.filter(
      (tramo, index) =>
        tramo.descripcion === descripcion &&
        tramos.findIndex(
          (t, i) =>
            i !== index &&
            t.descripcion === descripcion &&
            moment(t.desde).isSame(moment(tramo.desde)) &&
            moment(t.hasta).isSame(moment(tramo.hasta))
        ) !== -1
    );

    if (duplicateTramos.length > 0) {
      alert("Error: Los tramos no pueden tener la misma fecha de inicio y término");
      setLoading(false);
      return;
    }

    const flattenedDataArriendoCopy = [...flattenedDataArriendo];
    const serviciosArrayCopy = [...servicios];

    const indexToRemoveArriendo = flattenedDataArriendoCopy.findIndex(
      (item) => item.descripcion === descripcion
    );

    const indexToRemoveServicios = serviciosArrayCopy.findIndex(
      (item) =>
        item.descripcion.includes(descripcion) &&
        item.descripcion.includes("Gasto Comun")
    );

    const gastoComunItem = serviciosArrayCopy.find(
      (item) =>
        item.descripcion.includes(descripcion) &&
        item.descripcion.includes("Gasto Comun")
    );

    // Sincronización transaccional: desactivar los ítems reemplazados e
    // insertar/actualizar los tramos en una sola llamada
    const desactivarIds = [];
    const insertarItems = [];
    const actualizarItems = [];

    if (indexToRemoveArriendo !== -1) {
      const itemToRemove = flattenedDataArriendoCopy[indexToRemoveArriendo];
      if (typeof itemToRemove?.id === "number") {
        desactivarIds.push(itemToRemove.id);
      }
      flattenedDataArriendoCopy.splice(indexToRemoveArriendo, 1);
      flattenedDataArriendoCopy.push(...tramos);

      const matchingItems = flattenedDataArriendoCopy.filter(
        (item) => item.descripcion === descripcion
      );

      matchingItems.forEach((item, index) => {
        item.tramo = `Tramo ${index + 1}`;
        item.id = null;
      });

      flattenedDataArriendoCopy.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }
        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });

      flattenedDataArriendoCopy
        .map((item) => formatDatesIfNeeded(item, false))
        .forEach((item) => {
          if (item.id == null) {
            insertarItems.push(toSyncItem(item, monedaOptions));
          } else {
            actualizarItems.push(toSyncItem(item, monedaOptions));
          }
        });
    }

    if (indexToRemoveServicios !== -1) {
      const itemToRemove = serviciosArrayCopy[indexToRemoveServicios];
      if (typeof itemToRemove?.id === "number") {
        desactivarIds.push(itemToRemove.id);
      }
      serviciosArrayCopy.splice(indexToRemoveServicios, 1);
      // Add new tramos for Gasto Comun in serviciosArrayCopy

      tramos.forEach((tramo, index) => {
        serviciosArrayCopy.push({
          ...gastoComunItem,
          desde: tramo.desde,
          hasta: tramo.hasta,
          tramo: `Tramo ${index + 1}`,
          id: null,
        });
      });

      serviciosArrayCopy.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }
        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });
      serviciosArrayCopy
        .map((item) => formatDatesIfNeeded(item, false))
        .forEach((item) => {
          if (item.id == null) {
            insertarItems.push(toSyncItem(item, monedaOptions));
          } else {
            actualizarItems.push(toSyncItem(item, monedaOptions));
          }
        });
    }

    if (desactivarIds.length > 0 || insertarItems.length > 0 || actualizarItems.length > 0) {
      await sincronizarDetallesCotizacion(baseUrl, {
        idCotizacion,
        desactivar: desactivarIds,
        insertar: insertarItems,
        actualizar: actualizarItems,
      });
    }
    setShowTramoModalArriendo(false);
    await getDetalleData();
    setLoading(false);
  };


  // ---------------------------- 
  // Funcion de ordenamiento y calculo de cuotas
  //---------------------------- 
  const handleTramoConfirmacionCuota = async (rowData) => {
    if (loading) return;
    if (maxAmountOfCuotas === 1) {
      alert(
        "Si solo hay un mes o menos en el periodo no es posible pagar en cuotas"
      );
    }
    setLoading(true);
    let cuotasInside = cuotas;
    // Ensure the dates are in dd/mm/yyyy format

    if (cuotasInside > maxAmountOfCuotas) {
      cuotasInside = maxAmountOfCuotas;
    }

    const serviciosUnicosCopy = [...serviciosUnicos];
    const itemBeforeRemove = serviciosUnicosCopy.find(
      (item) => item.descripcion === rowData.descripcion
    );
    const indexToRemove = serviciosUnicosCopy.findIndex(
      (item) => item.descripcion === rowData.descripcion
    );

    if (indexToRemove !== -1) {
      const itemToRemove = serviciosUnicosCopy[indexToRemove];
      serviciosUnicosCopy.splice(indexToRemove, 1);

      // Calculate the number of months between desde and hasta
      const startDate = moment(rowData.desde, dateFormats, true).toDate();
      const endDate = moment(rowData.hasta, dateFormats, true).toDate();
      const tarifaCliente = rowData.tarifa_cliente;
      const totalDays = Math.ceil(
        (endDate - startDate) / (1000 * 60 * 60 * 24)
      );

      const daysPerCuota = Math.ceil(totalDays / cuotasInside);

      let currentStartDate = moment(startDate, dateFormats, true).toDate();

      for (let i = 0; i < cuotasInside; i++) {
        const newItem = { ...itemBeforeRemove };
        const daysToAdd =
          i === cuotasInside - 1 ? totalDays - daysPerCuota * i : daysPerCuota;

        const perCuota = (parseFloat(tarifaCliente) || 0) / cuotasInside;
        newItem.tarifa_cliente = (perCuota).toFixed(2);
        newItem.tramo = `Cuota ${i + 1}`;
        newItem.id = null;
        serviciosUnicosCopy.push(newItem);
        currentStartDate = moment(currentStartDate)
          .add(daysToAdd, "days")
          .toDate();
      }

      // Sincronización transaccional: desactivar el ítem original e insertar
      // las cuotas en una sola llamada
      const desactivarIds =
        typeof itemToRemove?.id === "number" ? [itemToRemove.id] : [];
      const insertarItems = serviciosUnicosCopy
        .filter((item) => item.id == null)
        .map((item) => toSyncItem(formatDatesIfNeeded(item, false), monedaOptions));

      if (desactivarIds.length > 0 || insertarItems.length > 0) {
        await sincronizarDetallesCotizacion(baseUrl, {
          idCotizacion,
          desactivar: desactivarIds,
          insertar: insertarItems,
          actualizar: [],
        });
      }
    }
    setShowTramoModalUnico(false);
    await getDetalleData();
    setLoading(false);
  };
  const clearTramosVariables = () => {
    setTramos([]);
    setTramoCounter(0);
  };
  const handleNewTramoArriendo = (rowData) => {
    // Limpia las variables relacionadas con los tramos antes de crear uno nuevo
    clearTramosVariables();

    // Establece el nombre del cuadro con la descripción del rowData
    setNombreCuadro(rowData.descripcion);

    // Convierte las fechas de "desde" y "hasta" a objetos Date utilizando moment
    const desdeDate = moment(rowData.desde, dateFormats, true).toDate();
    const hastaDate = moment(rowData.hasta, dateFormats, true).toDate();

    // Valida si las fechas son correctas, si no, muestra una alerta y detiene la ejecución
    if (
      !moment(rowData.desde, dateFormats, true).isValid() ||
      !moment(rowData.hasta, dateFormats, true).isValid()
    ) {
      alert("Fechas no válidas");
      return;
    }

    // Se crean dos objetos de tramo con las mismas fechas de inicio y fin
    const tramo1 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };
    const tramo2 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };

    // Convierte las fechas de tramo1 y tramo2 en objetos moment para su posterior manipulación
    tramo1.desde = moment(tramo1.desde, dateFormats, true);
    tramo1.hasta = moment(tramo1.hasta, dateFormats, true);

    tramo2.desde = moment(tramo2.desde, dateFormats, true);
    tramo2.hasta = moment(tramo2.hasta, dateFormats, true);

    // Establece la fecha de "hasta" general para el tramo
    setHastaTramoGeneral(hastaDate);

    // Guarda los tramos creados en el estado
    setTramos([tramo1, tramo2]);

    // Muestra el modal para la configuración del tramo de arriendo
    setShowTramoModalArriendo(true);
  };

  /**
   * Filtra un array eliminando un elemento específico
   * @param {Array} array - El array a filtrar
   * @param {Object} rowData - El elemento que no queremos incluir en el resultado
   * @return {Array} Un nuevo array sin el elemento especificado
   */
  const filterArray = (array, rowData) => {
    return array.filter((data) => data !== rowData);
  };

  /**
   * Formatea una fecha a "YYYY-MM-DD"
   * @param {string|Date} dateInput - La fecha de entrada en distintos formatos
   * @return {string} La fecha formateada en "YYYY-MM-DD" o muestra una alerta si el formato es inválido
   */
  function formatDateTramo(dateInput) {
    // Intenta convertir la fecha con los formatos permitidos
    const date = moment(dateInput, dateFormats, true);

    if (!date.isValid()) {
      alert("Fecha en formato inválido");
      return;
    }

    return date.format("YYYY-MM-DD");
  }

  /**
   * Actualiza un tramo si es necesario
   * @param {Array} array - El array de elementos con tramos
   * @param {Object} rowData - El elemento que se quiere actualizar
   * @return {Array} Un nuevo array con el tramo actualizado si corresponde
   */
  const updateTramoIfNeeded = (array, rowData) => {
    // Filtra los elementos que coinciden con la descripción del rowData
    const newArray = array.filter(
      (item) => item.descripcion === rowData.descripcion
    );

    if (newArray.length > 0) {
      // Se crea un nuevo objeto con el tramo actualizado
      const updatedItem = {
        ...newArray[0],
        tramo: "", // Se vacía el campo tramo
        desde: formatDateTramo(desde), // Se actualiza la fecha de inicio
        hasta: formatDateTramo(hasta), // Se actualiza la fecha de fin
        tarifa_cliente: newArray[0].tarifa_base, // Se asigna la tarifa base como tarifa del cliente
        descuento: 0, // Se reinicia el descuento a 0
      };

      // Se filtran los elementos que tienen la misma descripción para reemplazar el anterior
      const updatedArray = array.filter(
        (item) => item.descripcion !== rowData.descripcion
      );

      // Se añade el elemento actualizado al array
      updatedArray.push(updatedItem);

      return updatedArray;
    }

    return array; // Si no hay cambios, se devuelve el mismo array original
  };

  // Funcion para borrar lineas
  const handleBorrarLinea = async (itemABorrar, nombreArray) => {
    if (loading) return; // Si ya está en proceso de carga, se detiene la ejecución
    setLoading(true); // Se activa el estado de carga
    //console.log("[handleBorrarLinea] inicio", { nombreArray, id: itemABorrar?.id, descripcion: itemABorrar?.descripcion });

    let arrayToMaintain; // Array que almacenará los elementos que se deben mantener después del borrado
    let hasTramo =
      itemABorrar.tramo !== "" &&
      itemABorrar.tramo !== null &&
      itemABorrar.tramo !== undefined &&
      itemABorrar.tramo !== "null"; // Verifica si el item tiene un tramo definido

    let itemsToDelete = []; // Array que almacenará los elementos a eliminar

    // Si el ítem tiene tramos, se muestra una confirmación antes de eliminar
    if (hasTramo) {
      const confirmDelete = window.confirm(
        "El borrado de un item con tramos hará que todos los tramos se borren y vuelva a su estado original"
      );
      if (!confirmDelete) {
        setLoading(false);
        return;
      }
    }

    // Se determina qué tipo de elemento se va a eliminar según el nombre del array
    switch (nombreArray) {
      case "productos":
        // Filtra los productos que no tienen guion en la descripción
        const itemsWithoutHyphen = flattenedDataArriendo.filter(
          (item) => !item.descripcion.includes(" - ")
        );
        //console.log("[productos] itemsWithoutHyphen count:", itemsWithoutHyphen.length);
        // Si solo queda un producto y no tiene guion, se evita que la cotización quede vacía
        if (
          itemsWithoutHyphen.length === 1 &&
          !itemABorrar.descripcion.includes(" - ")
        ) {
          alert("No puede dejar la cotización sin producto");
          setLoading(false);
          return;
        } else {
          const originalArray = [...flattenedDataArriendo]; // Se mantiene el array original
          //console.log("[productos] originalArray count:", originalArray.length);

          // Si el ítem tiene tramos, se actualiza el tramo en lugar de eliminar directamente
          if (hasTramo) {
            arrayToMaintain = updateTramoIfNeeded(
              flattenedDataArriendo,
              itemABorrar
            );
          //console.log("[productos] updateTramoIfNeeded -> arrayToMaintain count:", arrayToMaintain.length);
          } else {
            arrayToMaintain = filterArray(flattenedDataArriendo, itemABorrar);
          //console.log("[productos] filterArray -> arrayToMaintain count:", arrayToMaintain.length);
          }

          // Se registran los ítems eliminados comparando el array original con el modificado
          if (originalArray.length > 0) {
            const deletedItems = originalArray.filter(
              (item) => !arrayToMaintain.includes(item)
            );
            deletedItems.forEach((item) => itemsToDelete.push(item));
            //console.log("[productos] deletedItems count:", deletedItems.length, deletedItems);
          }

          // Se verifica si el ítem sigue presente en el array luego de la eliminación
          const itemSecondPart = itemABorrar.descripcion;
          const itemStillPresent = arrayToMaintain.some(
            (item) => item.descripcion === itemABorrar.descripcion
          );
          //console.log("[productos] itemStillPresent:", itemStillPresent);

          // Si el ítem ya no está presente, se eliminan los relacionados en otros arrays
          if (!itemStillPresent) {
            const relatedServicios = servicios.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedServicios count:", relatedServicios.length, relatedServicios);
            relatedServicios.forEach((item) => itemsToDelete.push(item));

            const relatedServiciosUnicos = serviciosUnicos.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedServiciosUnicos count:", relatedServiciosUnicos.length, relatedServiciosUnicos);
            relatedServiciosUnicos.forEach((item) => itemsToDelete.push(item));

            const relatedFlattenedDataArriendo = flattenedDataArriendo.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedFlattenedDataArriendo count:", relatedFlattenedDataArriendo.length, relatedFlattenedDataArriendo);
            relatedFlattenedDataArriendo.forEach((item) =>
              itemsToDelete.push(item)
            );

            // Se eliminan del array los elementos que están en la lista de eliminación
            arrayToMaintain = arrayToMaintain.filter(
              (item) =>
                !itemsToDelete.some(
                  (deletedItem) => deletedItem.descripcion === item.descripcion
                )
            );
          } else {
            // Manejo especial para los "Gasto Comun" en los servicios
            const gastoComunItems = servicios.filter(
              (item) =>
                item.descripcion.includes("Gasto Comun") &&
                item.descripcion.split(" - ")[1] === itemABorrar.descripcion
            );
            //console.log("[productos] gastoComunItems count:", gastoComunItems.length, gastoComunItems);

            // Si hay más de un "Gasto Comun" con tramo, se actualiza en vez de eliminar
            if (gastoComunItems.length > 1 && hasTramo) {
              const updatedGastoComunItem = {
                ...gastoComunItems[0],
                tramo: "",
                desde: formatDateTramo(desde),
                hasta: formatDateTramo(hasta),
                id: null,
              };
              //console.log("[productos] updatedGastoComunItem:", updatedGastoComunItem);
              const updatedServicios = servicios.filter(
                (item) =>
                  !(
                    item.descripcion.includes("Gasto Comun") &&
                    item.descripcion.split(" - ")[1] === itemABorrar.descripcion
                  )
              );
              //console.log("[productos] updatedServicios count:", updatedServicios.length, updatedServicios);
              arrayToMaintain.push(updatedGastoComunItem);
              //console.log("[productos] arrayToMaintain count:", arrayToMaintain.length, arrayToMaintain);

              if (servicios.length > 0) {
                const originalServicios = [...servicios];
                const deletedServiciosItems = originalServicios.filter(
                  (item) => !updatedServicios.includes(item)
                );
                deletedServiciosItems.forEach((item) =>
                  itemsToDelete.push(item)
                );
                //console.log("[productos] deletedServiciosItems count:", deletedServiciosItems.length, deletedServiciosItems);
              }
            }
          }

          // Eliminación de elementos relacionados con "Obra Civil" si no hay adicionales
          const newArray = arrayToMaintain.filter(
            (item) =>
              item.tipo === "Adicional" &&
              item.descripcion.split(" - ")[1] ===
                itemABorrar.descripcion.split(" - ")[1]
          );
          //console.log("[productos] newArray count:", newArray.length, newArray);

          if (newArray.length < 1) {
            const relatedObraCivilItems = serviciosUnicos.filter(
              (item) =>
                item.descripcion.includes("Obra Civil") &&
                item.descripcion.split(" - ")[1] ===
                  itemABorrar.descripcion.split(" - ")[1]
            );
            //console.log("[productos] relatedObraCivilItems count:", relatedObraCivilItems.length, relatedObraCivilItems);
            relatedObraCivilItems.forEach((item) => itemsToDelete.push(item));
          }
        }
        break;
      case "servicios":
        const originalServicios = [...servicios];

        if (hasTramo) {
          arrayToMaintain = updateTramoIfNeeded(servicios, itemABorrar);
        } else {
          arrayToMaintain = filterArray(servicios, itemABorrar);
        }

        if (originalServicios.length > 0) {
          const deletedItemsServicios = originalServicios.filter(
            (item) => !arrayToMaintain.includes(item)
          );
          deletedItemsServicios.forEach((item) => itemsToDelete.push(item));
        }

        const newArrayServicios = arrayToMaintain.filter(
          (item) => item.descripcion === itemABorrar.descripcion
        );

        const isInternet =
          typeof itemABorrar?.descripcion === "string" &&
          itemABorrar.descripcion.toLowerCase().includes("internet");

        if (newArrayServicios.length < 1 && isInternet) {
          const suffix = itemABorrar.descripcion.includes(" - ")
            ? itemABorrar.descripcion.split(" - ")[1]
            : null;

          // Eliminar servicios únicos del mismo sufijo NO “Habilitacion Fibra”
          const unicosMismoSufijoNoHF = (serviciosUnicos || []).filter((su) => {
            const suDesc =
              typeof su?.descripcion === "string" ? su.descripcion.toLowerCase() : "";
            if (suffix) {
              const suSuffix = su.descripcion.includes(" - ")
                ? su.descripcion.split(" - ")[1]
                : null;
              return suSuffix === suffix && !suDesc.includes("habilitacion fibra") &&
              !suDesc.includes("obra civil");
            }
            return !suDesc.includes("habilitacion fibra");
          });

          unicosMismoSufijoNoHF.forEach((item) => itemsToDelete.push(item));
        }

        // SOLO eliminar “Habilitacion Fibra” cuando el item a borrar es Internet
        if (isInternet) {
          const relatedHabilitacionFibraItems = (serviciosUnicos || []).filter(
            (item) =>
              typeof item?.descripcion === "string" &&
              item.descripcion.toLowerCase().includes("habilitacion fibra") &&
              item.descripcion.split(" - ")[1] ===
                itemABorrar.descripcion.split(" - ")[1]
          );

          relatedHabilitacionFibraItems.forEach((item) =>
            itemsToDelete.push(item)
          );
        }
        break;
      case "unicos":
        const originalUnicos = [...serviciosUnicos];

        if (hasTramo) {
          arrayToMaintain = updateTramoIfNeeded(serviciosUnicos, itemABorrar);
        } else {
          arrayToMaintain = filterArray(serviciosUnicos, itemABorrar);
        }

        if (originalUnicos.length > 0) {
          const deletedItemsUnicos = originalUnicos.filter(
            (item) => !arrayToMaintain.includes(item)
          );
          deletedItemsUnicos.forEach((item) => itemsToDelete.push(item));
        }
        // Reiniciar el estado de cuotas si se elimina una cuota
        if (itemABorrar.tramo && itemABorrar.tramo.includes("Cuota")) {
          setCuotas(0);
        }
        break;
      default:
        break;
    }
    //console.log("[productos] itemsToDelete count:", itemsToDelete.length, itemsToDelete);
    //console.log("[productos] arrayToMaintain count:", arrayToMaintain.length, arrayToMaintain);

    // Desasociación del catálogo (producto_subproducto): solo subproductos
    // tipo "Adicional" (los Incluido se desasocian únicamente desde el
    // mantenedor). Cubre borrado directo y cascada (itemsToDelete). Si falla,
    // se aborta todo antes de tocar la cotización.
    const subproductosAdicionalesABorrar = itemsToDelete.filter(esSubproductoAdicional);
    if (subproductosAdicionalesABorrar.length > 0) {
      try {
        await desasociarSubproductosAdicionales(
          baseUrl,
          subproductosAdicionalesABorrar,
          flattenedDataArriendo
        );
      } catch (error) {
        console.error("Error al desasociar subproductos del catálogo.", error);
        alert(error.message || "No se pudo desasociar el subproducto del catálogo");
        setLoading(false);
        return;
      }
    }

    if (itemsToDelete.length > 0) {
      // Sincronización transaccional: desactiva los eliminados e inserta/actualiza
      // los sobrevivientes en una sola llamada (sin estado parcial intermedio)
      const desactivarIds = itemsToDelete
        .filter((item) => typeof item?.id === "number")
        .map((item) => item.id);
      const insertarItems = [];
      const actualizarItems = [];
      (arrayToMaintain || [])
        .map((item) => formatDatesIfNeeded(item, false))
        .forEach((item) => {
          if (item.id == null) {
            insertarItems.push(toSyncItem(item, monedaOptions));
          } else {
            actualizarItems.push(toSyncItem(item, monedaOptions));
          }
        });

      await sincronizarDetallesCotizacion(baseUrl, {
        idCotizacion,
        desactivar: desactivarIds,
        insertar: insertarItems,
        actualizar: actualizarItems,
      });
      //await getDetalleData();
    }

    //window.location.reload(true); // Se recarga la página para actualizar la información
    await getDetalleData();
    setLoading(false); // Se desactiva el estado de carga
  };

  // Funcion para seleccionar la fecha de tramo
  const selectFechaTramo = (index, newHasta) => {
    // Se crea una copia del array de tramos para actualizarlo sin modificar el original directamente
    let updatedTramos = [...tramos];

    // Se obtiene el tramo actual a modificar
    const currentTramo = updatedTramos[index];

    // Se convierten las fechas a objetos moment para facilitar su manipulación
    const newHastaMoment = moment(newHasta, dateFormats, true); // Nueva fecha de finalización ingresada
    const currentHastaMoment = moment(currentTramo.hasta, dateFormats, true); // Fecha de finalización actual del tramo
    const currentDesdeMoment = moment(currentTramo.desde, dateFormats, true); // Fecha de inicio actual del tramo
    const hastaTramoGeneralMoment = moment(
      hastaTramoGeneral,
      dateFormats,
      true
    ); // Fecha final general del tramo

    // Función que valida si el primer tramo es válido
    const isFirstTramoValid = () =>
      !newHastaMoment.isSame(hastaTramoGeneralMoment) && // La nueva fecha no debe ser igual a la fecha final general
      !newHastaMoment.isSame(currentHastaMoment) && // La nueva fecha no debe ser igual a la actual
      newHastaMoment.isAfter(currentDesdeMoment); // La nueva fecha debe ser posterior a la fecha de inicio del tramo

    // Función que valida si el último tramo es válido
    const isLastTramoValid = () =>
      tramoCounter === tramos.length - 1 && // Se verifica si es el último tramo
      newHastaMoment.isBefore(hastaTramoGeneralMoment); // La nueva fecha debe ser anterior a la fecha final general

    // Si el índice es 0, significa que estamos modificando el primer tramo
    if (index === 0) {
      if (isFirstTramoValid()) {
        // Se obtiene el siguiente tramo
        const secondTramo = updatedTramos[index + 1];

        // Se actualiza la fecha de finalización del tramo actual
        currentTramo.hasta = newHastaMoment.toDate();

        // Se actualiza la fecha de inicio del segundo tramo al día siguiente de la nueva fecha de finalización
        secondTramo.desde = newHastaMoment.clone().add(1, "day").toDate();

        // Se actualizan los tramos con las nuevas fechas
        updatedTramos = [currentTramo, secondTramo];
        setTramos(updatedTramos);

        // Se incrementa el contador de tramos
        setTramoCounter((prevCounter) => prevCounter + 1);
      } else {
        alert("no es valido"); // Se muestra una alerta si la nueva fecha no es válida
      }
    }
    // Si no es el primer tramo, pero es el último tramo
    else if (isLastTramoValid()) {
      // Se actualiza la fecha de finalización del tramo actual
      currentTramo.hasta = newHastaMoment.toDate();

      // Se crea un nuevo tramo con las fechas ajustadas
      const newTramo = {
        ...currentTramo,
        desde: newHastaMoment.clone().add(1, "day").toDate(), // Se establece la fecha de inicio un día después de la nueva fecha
        hasta: hastaTramoGeneralMoment.toDate(), // La fecha de finalización es la fecha final general
      };

      // Se actualiza el array de tramos, reemplazando el tramo modificado
      updatedTramos = updatedTramos.map((tramo, i) =>
        i === index ? currentTramo : tramo
      );

      // Se agrega el nuevo tramo al array de tramos
      updatedTramos.push(newTramo);

      // Se incrementa el contador de tramos
      setTramoCounter((prevCounter) => prevCounter + 1);

      // Se actualiza el estado con la nueva lista de tramos
      setTramos(updatedTramos);
    }
    // Si la nueva fecha no cumple ninguna condición, se muestra una alerta
    else {
      alert("aqui termina el ciclo");
    }
  };

  const matrixData = {};
  const [resumenMensual, setResumenMensual] = useState([]);

  /**
   * Calcula los cargos mensuales en función de un conjunto de cargos y si es un servicio único.
   * @param {Array} charges - Lista de cargos a procesar.
   * @param {boolean} isUniqueService - Indica si se trata de un servicio único.
   * @return {Object} Un objeto con claves "YYYY-MM" representando meses y valores con el total acumulado por mes.
   */
  function calculateMonthlyCharges(charges, isUniqueService = false) {
    const monthlyCharges = {}; // Objeto para almacenar los cargos mensuales
    charges.forEach((charge) => {
      // Convierte las fechas "desde" y "hasta" a UTC para evitar problemas de zona horaria
      const startDateUTC = moment(charge.desde, dateFormats, true)
        .startOf("day")
        .utc();
      const endDateUTC = moment(charge.hasta, dateFormats, true)
        .startOf("day")
        .utc();

      // Si es un servicio único y no tiene tramos, se cobra todo en el primer mes (diferencia por moneda)
      if (isUniqueService && (!charge.tramo || charge.tramo === "null")) {
        const firstMonthKey = startDateUTC.format("YYYY-MM");
        let monthlyCharge = 0;
        if (charge.moneda === "UF") {
          monthlyCharge = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          //console.log(monthlyCharge);
        } else if (charge.moneda === "CLP") {
          monthlyCharge = charge.tarifa_mensual ? parseFloat(charge.tarifa_mensual) : 0;
          //console.log(monthlyCharge);
        } else {
          monthlyCharge = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          //console.log(monthlyCharge);
        }
        // Se agrega el cargo solo al primer mes
        if (!monthlyCharges[firstMonthKey]) {
          monthlyCharges[firstMonthKey] = 0;
        }
        monthlyCharges[firstMonthKey] += parseFloat(monthlyCharge);
      }
      // Si es un servicio único con cuotas (Cuota X), se distribuye en diferentes meses
      else if (isUniqueService && charge.tramo.includes("Cuota")) {
        // Extrae el número de cuota desde el texto "Cuota X" (Ejemplo: "Cuota 2" → 2)
        const cuotaMatch = charge.tramo.match(/Cuota (\d+)/);

        if (cuotaMatch && cuotaMatch[1]) {
          const cuotaNumber = parseInt(cuotaMatch[1], 10); // Convierte el número de cuota a entero

          // Calcula el mes en el que se debe aplicar la cuota
          const monthWithOffset = startDateUTC
            .clone()
            .add(cuotaNumber - 1, "month");

          // Verifica que el mes calculado esté dentro del período válido (antes de la fecha de finalización)
          if (monthWithOffset.isAfter(endDateUTC)) {
            return;
          }

          const monthKey = monthWithOffset.format("YYYY-MM");

          // Obtiene el monto de la cuota (diferencia por moneda)    
          let monthlyCuota = 0;
          if (charge.moneda === "UF") {
            monthlyCuota = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          } else if (charge.moneda === "CLP") {
            monthlyCuota = charge.tarifa_mensual ? parseFloat(charge.tarifa_mensual) : 0;
          } else {
            monthlyCuota = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          }

          // Suma la cuota al mes correspondiente
          if (!monthlyCharges[monthKey]) {
            monthlyCharges[monthKey] = 0;
          }
          //console.log(monthlyCuota);
          monthlyCharges[monthKey] += monthlyCuota;
        } else {
          console.error("Invalid cuota format in tramo:", charge.tramo); // Muestra un error si el formato de cuota es inválido
        }
      }
      // Caso general: Se distribuyen los cargos de manera proporcional por mes
      else {
        let currentDate = startDateUTC.clone();
        while (currentDate.isSameOrBefore(endDateUTC)) {
          const currentMonthKey = currentDate.format("YYYY-MM");
          let daysInPeriod = 30; // Se asume que cada mes tiene 30 días por defecto

          // Caso donde todo el período cae dentro de un solo mes
          if (
            startDateUTC.isSame(endDateUTC, "month") &&
            startDateUTC.isSame(endDateUTC, "year")
          ) {
            // Calcula los días entre la fecha de inicio y la de fin dentro del mismo mes
            daysInPeriod = endDateUTC.date() - startDateUTC.date() + 1;
          }
          // Caso del primer mes del período
          else if (
            currentDate.isSame(startDateUTC, "month") &&
            currentDate.isSame(startDateUTC, "year")
          ) {
            // Calcula los días desde la fecha de inicio hasta el final del mes
            daysInPeriod = Math.min(
              currentDate.endOf("month").date() - startDateUTC.date() + 1,
              30
            );
          }
          // Caso del último mes del período
          else if (
            currentDate.isSame(endDateUTC, "month") &&
            currentDate.isSame(endDateUTC, "year")
          ) {
            // const endOfMonthDate = currentDate.endOf("month").date();
            // if (endDateUTC.date() === endOfMonthDate) {
            //   daysInPeriod = 30;
            // } else {
            //   daysInPeriod = endDateUTC.date();
            // }

            // FIX: base 30 siempre
            daysInPeriod = Math.min(endDateUTC.date(), 30);
          }
          // En los meses intermedios, "daysInPeriod" se mantiene en 30

          // Se calcula el cargo diario
          const dailyCharge = charge.tarifa_diaria
            ? parseFloat(charge.tarifa_diaria)
            : 0;
          const monthlyCharge =
            charge.relacion === "servicio" &&
            !charge.descripcion.includes("Gasto Comun")
              ? charge.tarifa_mensual // Si es un servicio, usa la tarifa mensual
              : dailyCharge * daysInPeriod; // Si no, calcula con la tarifa diaria

          // Se inicializa el mes si no existe
          if (!monthlyCharges[currentMonthKey]) {
            monthlyCharges[currentMonthKey] = 0;
          }
          //console.log(monthlyCharge);
          // Se suma el cargo mensual calculado al mes correspondiente
          monthlyCharges[currentMonthKey] += parseFloat(monthlyCharge);

          // Se avanza al siguiente mes
          currentDate.add(1, "month").startOf("month");
        }
      }
    });
    //console.log(monthlyCharges);
    return monthlyCharges; // Devuelve el objeto con los cargos distribuidos por mes
  }

  /**
   * Normaliza una fecha a formato "YYYY-MM"
   * @param {string} dateString - La fecha en distintos formatos posibles
   * @return {string|null} La fecha normalizada en formato "YYYY-MM" o null si el formato no es válido
   */
  const normalizeDate = (dateString) => {
    // Lista de formatos de fecha aceptados
    const formats = ["YYYY-MM","YYYY/MM","MM/YYYY","MMM YYYY","MMMM YYYY","YYYY-MM-DD","YYYY/MM/DD","DD/MM/YYYY","DD-MM-YYYY",];

    // Intenta convertir la fecha con los formatos permitidos
    const date = moment(dateString, formats, true);

    // Si la fecha es válida, la devuelve en formato "YYYY-MM", si no, devuelve null
    return date.isValid() ? date.format("YYYY-MM") : null;
  };

  // Estado para controlar si se debe mostrar el resumen mensual
  const [verResumenMensual, setVerResumenMensual] = useState(false);

  /**
   * Formatea un mes dado en formato "YYYY-MM" a su nombre en texto completo
   * @param {string} dateString - La fecha en formato "YYYY-MM"
   * @return {string} Nombre del mes en texto (ej. "January", "February")
   */
  const formatMonth = (dateString) => {
    const date = moment(dateString, "YYYY-MM");
    return date.format("MMMM"); // Devuelve el nombre del mes en inglés
  };

  // Convierte el objeto "resumenMensual" en un array de objetos con información formateada
  const allData = Object.entries(resumenMensual).map(([date, value]) => {
    const normalizedDate = normalizeDate(date); // Normaliza la fecha
    if (!normalizedDate) {
      throw new Error(`Invalid date format: ${date}`); // Lanza un error si la fecha no es válida
    }
    return {
      id: normalizedDate, // Guarda la fecha normalizada como identificador
      formattedMonth: formatMonth(normalizedDate), // Obtiene el nombre del mes formateado
      value: `${value.toLocaleString("en-US").replace(".", ",")} UF`, // Formatea el valor en UF
    };
  });

  // Llena la estructura "matrixData" con los valores organizados por año y mes
  allData.forEach(({ id, value }) => {
    const [year, month] = id.split("-"); // Extrae el año y el mes del ID de fecha
    const paddedMonth = month.padStart(2, "0"); // Asegura que el mes tenga dos dígitos

    // Si el año no existe en la matriz, se crea
    if (!matrixData[year]) {
      matrixData[year] = {};
    }

    // Se almacena el valor en la matriz bajo el año y el mes correspondiente
    matrixData[year][paddedMonth] = value;
  });

  // Extrae todos los meses únicos presentes en los datos
  const months = Object.keys(
    allData.reduce((acc, { id }) => {
      const [, month] = id.split("-"); // Obtiene el mes de la fecha normalizada
      acc[month] = true; // Marca el mes como existente en el conjunto
      return acc;
    }, {})
  );

  const sortedMonths = months.sort((a, b) => a - b);

  moment.locale("es");

  const columns = [
    { field: "year", header: "Año" },
    ...sortedMonths.map((month) => {
      const monthName = moment(month, "M")
        .locale("es") // Ensure locale is set for each formatting
        .format("MMMM")
        .replace(/^\w/, (c) => c.toUpperCase());

      return {
        field: month,
        header: monthName,
      };
    }),
  ];

  // -------------------------------------------------------
  // cuadro resumen mensual
  // -------------------------------------------------------
  const handleShowResumenMensual = () => {
    // Se combinan los arrays de cargos que se deben procesar
    const chargesArrays = [flattenedDataArriendo, servicios]; // Incluye productos y servicios
    const uniqueServiceCharges = serviciosUnicos; // Incluye servicios únicos
    const combinedMonthlyCharges = {}; // Objeto para almacenar los cargos combinados por mes

    // Se calcula el total mensual de los cargos regulares (productos y servicios)
    chargesArrays.forEach((charges) => {
      const monthlyCharges = calculateMonthlyCharges(charges, false); // Se calculan los cargos mensuales

      // Se combinan los cargos mensuales en un solo objeto sumando los valores de cada mes
      Object.keys(monthlyCharges).forEach((key) => {
        if (!combinedMonthlyCharges[key]) {
          combinedMonthlyCharges[key] = 0; // Se inicializa si no existe
        }
        combinedMonthlyCharges[key] += monthlyCharges[key]; // Se suman los valores de cada mes
      });
    });

    // Se calculan los cargos mensuales de los servicios únicos
    const monthlyUniqueCharges = calculateMonthlyCharges(
      uniqueServiceCharges,
      true
    );

    // Se suman los cargos de los servicios únicos al total combinado
    Object.keys(monthlyUniqueCharges).forEach((key) => {
      if (!combinedMonthlyCharges[key]) {
        combinedMonthlyCharges[key] = 0; // Se inicializa si no existe
      }
      combinedMonthlyCharges[key] += monthlyUniqueCharges[key]; // Se suman los valores de cada mes
    });

    /*const monthlyChargesArriendo = calculateMonthlyCharges(flattenedDataArriendo, false);
    console.log("Cargos mensuales ARRIENDO (productos y subproductos):");
    console.table(monthlyChargesArriendo);
    const monthlyChargesServiciosRegulares = calculateMonthlyCharges(servicios, false);
    console.log("Cargos mensuales SERVICIOS regulares:");
    console.table(monthlyChargesServiciosRegulares);
    console.table(combinedMonthlyCharges);*/

    // Se almacena el resumen mensual en el estado
    setResumenMensual(combinedMonthlyCharges);

    // Se activa la visualización del resumen mensual
    setVerResumenMensual(true);
  };

  const years = Object.keys(matrixData);

  // Transform matrixData into matrixArray
  const matrixArray = years.map((year) => {
    const yearData = { year: year }; // Include the year field
    sortedMonths.forEach((month) => {
      const monthField = String(month).padStart(2, "0"); // Ensure month is two digits
      yearData[monthField] = matrixData[year][month] || ""; // Provide default value if missing
    });
    return yearData;
  });

  /**
   * Actualiza los datos de una cotización enviándolos a la API.
   * @param {Object} item - Objeto que contiene la información del ítem de la cotización.
   * @param {boolean} isCerrar - Indica si se está cerrando la cotización.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const postUpdateDataCotizacion = async (item) => {
    try {
      return await actualizarDetalleCotizacion(
        baseUrl,
        buildActualizarDetalleParams(item, monedaOptions)
      );
    } catch (error) {
      console.error(`Error al actualizar el detalle de cotización:`, error);
      throw error;
    }
  };

  /**
   * Actualiza una cotización enviando los datos a la API.
   * @param {number} idCotizacion - ID de la cotización a actualizar.
   * @param {number} idCliente - ID del cliente asociado a la cotización.
   * @param {number} idEstado - ID del estado actual de la cotización.
   * @param {number} idCreador - ID del usuario que creó la cotización.
   * @param {string} desde - Fecha de inicio de la cotización en formato "YYYY-MM-DD".
   * @param {string} hasta - Fecha de finalización de la cotización en formato "YYYY-MM-DD".
   * @param {number} aviso - Número de días de aviso previo para la cotización.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  /**
   * Formatea una fecha en formato "DD/MM/YYYY" a "YYYY-MM-DD".
   * @param {string} dateString - Fecha en formato "DD/MM/YYYY".
   * @return {string} Fecha formateada en "YYYY-MM-DD" o la misma fecha si no coincide con el formato esperado.
   */
  function formatDate(dateString) {
    // Se divide la fecha en partes usando "/"
    const parts = dateString.split("/");

    // Si la fecha tiene tres partes, se asume que es "DD/MM/YYYY"
    if (parts.length === 3) {
      const [day, month, year] = parts;

      // Se asegura de que el día y el mes tengan dos dígitos
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");

      // Retorna la fecha en el formato "YYYY-MM-DD"
      return `${year}-${formattedMonth}-${formattedDay}`;
    }

    // Si no tiene el formato esperado, devuelve la fecha sin modificar
    return dateString;
  }

  /**
   * Obtiene el vencimiento vigente de la cotización normalizado a "YYYY-MM-DD".
   * @return {string|null} Vencimiento normalizado o null si no existe / falla.
   */
  const obtenerVencimiento = async () => {
    try {
      const cotResp = await getCotizacionById(baseUrl, idCotizacion);
      if (cotResp?.mensaje === "OK" && cotResp.cotizacion?.vencimiento) {
        const cv = cotResp.cotizacion.vencimiento;

        if (typeof cv === "string") {
          // Soporta "DD/MM/YYYY" y "YYYY-MM-DD" de forma estricta
          const m = cv.includes("/")
            ? moment(cv, "DD/MM/YYYY", true)
            : moment(cv, "YYYY-MM-DD", true);
          return m.isValid() ? m.format("YYYY-MM-DD") : null;
        } else if (cv instanceof Date) {
          return moment(cv).format("YYYY-MM-DD");
        } else if (typeof cv?.format === "function") {
          return cv.format("YYYY-MM-DD");
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  };

  const combinarTarifasCalculadas = (items) => {
    const tarifasPorId = new Map(
      [...flattenedDataArriendo, ...servicios, ...serviciosUnicos]
        .filter((item) => item.id != null)
        .map((item) => [item.id, item])
    );
    return items.map((item) => {
      const calculado = item.id != null ? tarifasPorId.get(item.id) : null;
      return calculado
        ? {
            ...item,
            tarifa_diaria: calculado.tarifa_diaria,
            tarifa_mensual: calculado.tarifa_mensual,
          }
        : item;
    });
  };

  /**
   * Guarda la cotización actualizando los datos en la API.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const guardarCotizacion = async (items) => {
    // Se combinan todos los elementos de la cotización en un solo array
    const allItems = Array.isArray(items) ? items : detallesCobro; // EL FINAL viene de la pagina cotizacionActions
    try {
      setLoading(true); // Se activa el estado de carga

      // Se formatean las fechas de los elementos si es necesario
      const formattedAllItems = combinarTarifasCalculadas(allItems).map(
        (item) => formatDatesIfNeeded(item, false)
      );

      // Sincronización transaccional: desactivar / insertar / actualizar en una
      // sola llamada (el backend aplica todo atómicamente y recalcula la cabecera)
      const itemsToUpdate = formattedAllItems.filter((i) => i.id != null);
      const itemsToInsert = formattedAllItems.filter((i) => i.id == null);

      // 1) Actualizar rango de fechas de la cotización con base en los ítems
      const fechasDesde = formattedAllItems.map((item) =>
        moment(item.desde, "YYYY-MM-DD")
      );
      const fechasHasta = formattedAllItems.map((item) =>
        moment(item.hasta, "YYYY-MM-DD")
      );

      const fechaMin = moment.min(fechasDesde);
      const fechaMax = moment.max(fechasHasta);

      const desdeTransformed = formatDate(fechaMin.format("YYYY-MM-DD"));
      const hastaTransformed = formatDate(fechaMax.format("YYYY-MM-DD"));

      const vencimiento = await obtenerVencimiento();

      await sincronizarDetallesCotizacion(baseUrl, {
        idCotizacion,
        desactivar: itemsPorEliminar
          .filter((item) => typeof item?.id === "number")
          .map((item) => item.id),
        insertar: itemsToInsert.map((item) => toSyncItem(item, monedaOptions)),
        actualizar: itemsToUpdate.map((item) => toSyncItem(item, monedaOptions)),
        cabecera: {
          idEstado: cotizacion?.estado?.id_estado,
          desde: desdeTransformed,
          hasta: hastaTransformed,
          aviso: 0,
          observacion,
          vencimiento,
        },
      });

      // Refrescar detalle
      await getDetalleData();
      setLoading(false);
    } catch (error) {
      console.error("Error posting data:", error);
      setLoading(false); // Se desactiva el estado de carga en caso de error
    }
  };

  // Funcion para cerrar un contrato (COTIZACION -> ASIGNACION).
  // Arma el payload de detalles (mismo contrato que sincronizarDetallesCotizacion)
  // y delega en ejecutarCierreContrato: una llamada transaccional al backend
  // principal y, si el cierre quedó OK, el registro del documento en
  // contratos.service. Si la transacción falla se muestra el mensaje del
  // backend y NO se navega (quedan los datos en pantalla para reintentar).
  const cerrarContrato = async (finalitems) => {
    try {
      // Se activa el estado de carga para cotizacionActions
      setLoading(true);
      setLoadingAsig(true);

      // Se formatean las fechas de los elementos si es necesario
      const formattedAllItems = combinarTarifasCalculadas(
        finalitems ?? []
      ).map((item) => formatDatesIfNeeded(item, false));
      const itemsToUpdate = formattedAllItems.filter((i) => i.id != null);
      const itemsToInsert = formattedAllItems.filter((i) => i.id == null);

      // Rango de fechas de la cotización con base en los ítems
      const fechasDesde = formattedAllItems.map((item) =>
        moment(item.desde, "YYYY-MM-DD")
      );
      const fechasHasta = formattedAllItems.map((item) =>
        moment(item.hasta, "YYYY-MM-DD")
      );
      const desdeTransformed = formatDate(moment.min(fechasDesde).format("YYYY-MM-DD"));
      const hastaTransformed = formatDate(moment.max(fechasHasta).format("YYYY-MM-DD"));

      const detallesPayload = {
        idCotizacion,
        desactivar: itemsPorEliminar
          .filter((item) => typeof item?.id === "number")
          .map((item) => item.id),
        insertar: itemsToInsert.map((item) => toSyncItem(item, monedaOptions)),
        actualizar: itemsToUpdate.map((item) => toSyncItem(item, monedaOptions)),
        cabecera: {
          desde: desdeTransformed,
          hasta: hastaTransformed,
          observacion,
          vencimiento: await obtenerVencimiento(),
        },
      };

      const { aborted } = await ejecutarCierreContrato({
        baseUrl,
        urlContratos,
        idCotizacion,
        idCliente,
        diasAviso,
        diasFirma,
        detallesPayload,
        navigate,
      });
      if (aborted) setLoading(false);

    } catch (error) {
      console.error("Error al cerrar el contrato:", error);
      window.alert(error?.message || "Ocurrió un error al cerrar el contrato");
      setLoading(false);
    } finally {
      setLoadingAsig(false);
    }
  };

  // Catálogo de tipos de documento de venta (tabla tipo_documento): fuente
// única para los dropdowns de cobro; con respaldo del hook si el servicio falla
const { tiposDocumento } = useTiposDocumento(baseUrl);
const cobroOptions = tiposDocumento.map((tipo) => ({
  label: tipo.descripcion,
  value: tipo.descripcion,
}));

  const handleTablaChange = async (rowData, newValue, tabla, campo) => {

    // Para Gasto Comun la tarifa_base es derivada en runtime (10% de la tarifa
    // mensual del arriendo) y solo vive en el estado `servicios`; detallesCobro
    // conserva la de la BD (0). Se usa como base de calculo para que el
    // descuento se calcule y persista correctamente.
    const tarifaBaseServicios = new Map(
      tabla === "servicios"
        ? servicios
            .filter((s) => s.id != null)
            .map((s) => [s.id, parseFloat(s.tarifa_base) || 0])
        : []
    );
    const tarifaBasePara = (item) =>
      tarifaBaseServicios.get(item.id) ?? item.tarifa_base;

    const updateData = (prevData) => {
      return prevData.map((item) => {
        if (
          item.descripcion === rowData.descripcion &&
          item.tramo === rowData.tramo &&
          item.id === rowData.id
        ) {
          let updatedItem = { ...item };

          if (campo === "descuento") {
            const newTarifa = tarifaBasePara(item) * (1 - newValue / 100);
            updatedItem = {
              ...updatedItem,
              descuento: newValue,
              tarifa_cliente: newTarifa,
            };
          } else if (campo === "tarifa_cliente") {
            if (item.moneda === "CLP") {
              // Para filas CLP el descuento se omite (tarifa_base está en UF)
              updatedItem = {
                ...updatedItem,
                tarifa_cliente: newValue,
                descuento: 0,
              };
            } else {
              const tarifaBase = tarifaBasePara(item);
              const percentageDifference =
                ((newValue - tarifaBase) / tarifaBase) * 100;
              updatedItem = {
                ...updatedItem,
                tarifa_cliente: newValue,
                descuento: -1 * percentageDifference,
              };
            }
          } else if (
            campo === "cantidad" &&
            tabla === "servicios" &&
            rowData.descripcion.includes("Internet")
          ) {
            let cantidad = newValue;
            const numberOfTenths = Math.floor(cantidad / 10);

            const ufExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "UF")
                ?.tipoCambio || 1;

            // Find USD exchange rate
            const usdExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "USD")
                ?.tipoCambio || 1;

            // Amount in UF
            const amountInUF = numberOfTenths * item.tarifa_base;

            // Convert UF to CLP
            const amountInCLP = amountInUF * ufExchangeRate;

            // Convert CLP to USD
            const amountInUSD = amountInCLP / usdExchangeRate;

            if (newValue > 200) {
              cantidad = 200;
            }

            const additionalTarifaBase =
              rowData.moneda === "UF"
                ? amountInUF
                : rowData.moneda === "USD"
                ? amountInUSD
                : amountInCLP;

            updatedItem = {
              ...updatedItem,
              cantidad: cantidad,
              tarifa_cliente: additionalTarifaBase,
            };
          } else if (campo === "desde" || campo === "hasta") {
            //console.log("updatedItem", updatedItem);
            //console.log("newValue", newValue);
            const date = moment(newValue, "YYYY-MM-DD", true);
            //console.log("date", date);
            if (date.isValid()) {
              updatedItem = {
                ...updatedItem,
                [campo]: date.format("YYYY-MM-DD"),
              };
            }
          } else if (
            campo === "moneda" &&
            tabla === "servicios" &&
            rowData.descripcion.includes("Internet")
          ) {
            let cantidad = rowData.cantidad;
            const numberOfTenths = Math.floor(cantidad / 10);

            const ufExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "UF")
                ?.tipoCambio || 1;

            // Find USD exchange rate
            const usdExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "USD")
                ?.tipoCambio || 1;

            // Amount in UF
            const amountInUF = numberOfTenths * item.tarifa_base;

            // Convert UF to CLP
            const amountInCLP = amountInUF * ufExchangeRate;

            // Convert CLP to USD
            const amountInUSD = amountInCLP / usdExchangeRate;

            const additionalTarifaBase =
              newValue === "UF"
                ? amountInUF
                : newValue === "USD"
                ? amountInUSD
                : amountInCLP;

            updatedItem = {
              ...updatedItem,
              cantidad: cantidad,
              tarifa_cliente: additionalTarifaBase,
              moneda: newValue,
            };

          } else if (campo === "agrupamiento") {
            updatedItem = {
              ...updatedItem,
              agrupamiento: newValue
            };
          } else {
            updatedItem = {
              ...updatedItem,
              [campo]: newValue,
            };
            // Al cambiar a CLP se omite el descuento
            if (campo === "moneda" && newValue === "CLP") {
              updatedItem = { ...updatedItem, descuento: 0 };
            }
          }

          return updatedItem;
        }
        return item;
      });
    };

    if (tabla === "servicios") {
      setServicios((prevServicios) =>
        prevServicios.map((item) => {
          if (item.id === rowData.id) {
            let updatedItem = { ...item, [campo]: newValue };
            // Al cambiar a CLP se omite el descuento
            if (campo === "moneda" && newValue === "CLP") {
              updatedItem.descuento = 0;
            }
            if (campo === "descuento") {
              const tarifaBase = parseFloat(item.tarifa_base) || 0;
              const descuento = parseFloat(newValue) || 0;
              updatedItem.tarifa_cliente = (tarifaBase * (1 - descuento / 100)).toFixed(5);
            }
            if (campo === "tarifa_cliente") {
              if (item.moneda === "CLP") {
                // Para filas CLP el descuento se omite (tarifa_base está en UF)
                updatedItem.descuento = 0;
              } else {
                const tarifaBase = parseFloat(item.tarifa_base) || 0;
                const tarifaCliente = parseFloat(newValue) || 0;
                if (tarifaBase > 0) {
                  updatedItem.descuento = (((tarifaBase - tarifaCliente) / tarifaBase) * 100).toFixed(5);
                }
              }
            }
            return updatedItem;
          }
          return item;
        })
      );
    }

    if (tabla === "flattened") {
      setFlattenedDataArriendo((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    } else if (tabla === "servicios") {
      setServicios((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    } else if (tabla === "unicos") {
      setServiciosUnicos((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    }

    // ——————————————————————————————
    // ACTUALIZA detallesCobro (misma lógica de cálculo)
    // ——————————————————————————————
    //  setDetallesCobro ( prev =>
    //    prev . map ( item =>
    //    item . id === rowData . id
    //    ? { ... item , [ campo ]: newValue }
    //    : item
    //    )
    //  );
    setDetallesCobro((prevData) => updateData(prevData));
  };

  const handleTramoConfirmationServicio = async (descripcion) => {
    if (loading) return;
    setLoading(true);
    const duplicateTramos = tramos.filter(
      (tramo, index) =>
        tramo.descripcion === descripcion &&
        tramos.findIndex(
          (t, i) =>
            i !== index &&
            t.descripcion === descripcion &&
            moment(t.desde).isSame(moment(tramo.desde)) &&
            moment(t.hasta).isSame(moment(tramo.hasta))
        ) !== -1
    );

    if (duplicateTramos.length > 0) {
      alert("Error: Los tramos no pueden tener la misma fecha de inicio y término");
      setLoading(false);
      return;
    }
    const serviciosInside = [...servicios];
    const indexToRemove = servicios.findIndex((item) => item.descripcion === descripcion);

    if (indexToRemove !== -1) {
      const itemToRemove = serviciosInside[indexToRemove];
      serviciosInside.splice(indexToRemove, 1);

      serviciosInside.push(...tramos);
      const matchingItems = serviciosInside.filter(
        (item) => item.descripcion === descripcion
      );

      matchingItems.forEach((item, index) => {
        item.tramo = `Tramo ${index + 1}`;
        item.id = null;
      });

      serviciosInside.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }

        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });

      // Sincronización transaccional: desactivar el ítem original e
      // insertar/actualizar los tramos en una sola llamada
      const desactivarIds =
        typeof itemToRemove?.id === "number" ? [itemToRemove.id] : [];
      const insertarItems = [];
      const actualizarItems = [];
      serviciosInside
        .map((item) => formatDatesIfNeeded(item, false))
        .forEach((item) => {
          if (item.id == null) {
            insertarItems.push(toSyncItem(item, monedaOptions));
          } else {
            actualizarItems.push(toSyncItem(item, monedaOptions));
          }
        });

      if (desactivarIds.length > 0 || insertarItems.length > 0 || actualizarItems.length > 0) {
        await sincronizarDetallesCotizacion(baseUrl, {
          idCotizacion,
          desactivar: desactivarIds,
          insertar: insertarItems,
          actualizar: actualizarItems,
        });
      }
    }
    setShowTramoModalServicio(false);
    await getDetalleData();
    setLoading(false);
  };
  const [visible, setVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState(null);
  const [typeOfAdd, setTypeOfAdd] = useState("");

  // Hook useEffect para actualizar las tarifas mensuales de los productos de arriendo
  useEffect(() => {
    // Verifica si hay datos en flattenedDataArriendo y si las opciones de moneda ya fueron obtenidas
    if (flattenedDataArriendo.length > 0 && monedaOptionsFetched) {
      // Se actualizan los datos de arriendo recalculando la tarifa mensual con metraje
      const updatedData = flattenedDataArriendo.map((item) => {
        const updatedItem = { ...item };
        // Calcula la tarifa mensual del arriendo en función del metraje y la moneda
        calculateTarifaMensualWithMetraje(updatedItem, monedaOptions);
        return updatedItem;
      });

      // Si los datos actualizados son distintos a los originales, se actualiza el estado
      if (!isEqual(updatedData, flattenedDataArriendo)) {
        setFlattenedDataArriendo(sortDataByProductAndSubProduct(updatedData));
      }
    }

    // Se extraen los productos únicos de arriendo
    const uniqueProducts = [];
    const descriptions = new Set();

    // Se filtran solo los productos que no se han agregado previamente
    flattenedDataArriendo.forEach((item) => {
      if (item.relacion === "producto" && !descriptions.has(item.descripcion)) {
        uniqueProducts.push(item);
        descriptions.add(item.descripcion);
      }
    });

    // Se actualiza el estado con los productos únicos
    setProducts(uniqueProducts);

    // Se ejecuta este efecto cada vez que cambian flattenedDataArriendo o monedaOptionsFetched
  }, [flattenedDataArriendo, monedaOptionsFetched]);

  // Hook useEffect para calcular el subtotal de arriendo
  useEffect(() => {
    // Verifica si hay datos en flattenedDataArriendo antes de calcular el subtotal
    if (flattenedDataArriendo.length > 0) {
      const subtotalArriendo = calculateSubtotal(flattenedDataArriendo);
      // Se actualiza el estado con el subtotal calculado
      setSubtotalArriendo(subtotalArriendo);
    }
    // Se ejecuta cada vez que cambian los datos de flattenedDataArriendo
  }, [flattenedDataArriendo]);

  // Hook useEffect para actualizar las tarifas mensuales de los servicios
  useEffect(() => {
    // Verifica si hay datos en servicios y si las opciones de moneda ya fueron obtenidas
    if (servicios.length > 0 && monedaOptionsFetched) {
      // Se actualizan los datos de servicios recalculando la tarifa mensual
      const updatedData = servicios.map((item) => {
        const updatedItem = { ...item };
        // Calcula la tarifa mensual de los servicios en función de la moneda y el subtotal del arriendo
        calculateTarifaMensualServicios(
          updatedItem,
          monedaOptions,
          flattenedDataArriendo,
          subtotalArriendo
        );
        return updatedItem;
      });
      // Si los datos actualizados son distintos a los originales, se actualiza el estado
      if (!isEqual(updatedData, servicios)) {
        setServicios(sortDataByProductAndSubProduct(updatedData));
      }
    }
    // Se ejecuta cada vez que cambian servicios, monedaOptionsFetched o subtotalArriendo
  }, [servicios, monedaOptionsFetched, subtotalArriendo]);

  useEffect(() => {
    if (servicios.length > 0) {
      const subtotalArriendo = calculateSubtotal(servicios);
      setSubtotalServicios(subtotalArriendo);
    }
  }, [servicios]);

  useEffect(() => {
    if (serviciosUnicos.length > 0 && monedaOptionsFetched) {
      const updatedData = serviciosUnicos.map((item) => {
        const updatedItem = { ...item };
        calculateTarifaMensualServiciosUnicos(updatedItem, monedaOptions);
        return updatedItem;
      });
      if (!isEqual(updatedData, serviciosUnicos)) {
        setServiciosUnicos(sortDataByProductAndSubProduct(updatedData));
      }
    }
  }, [serviciosUnicos, monedaOptionsFetched]);

  function isEqual(objA, objB) {
    return JSON.stringify(objA) === JSON.stringify(objB);
  }

  //abrir dialogo de agregar servicio
  const openDialog = (typeOfAdd) => {
    if (typeOfAdd === "subproducto") {
      setShowSubproductoDialog(true);
      return;
    }
    setTypeOfAdd(typeOfAdd);
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setshowProductForm2(false);
    setVisible(true);
    
    // Si solo hay un producto, lo seleccionamos automáticamente
    if (products.length === 1) {
      setSelectedProduct(products[0]);
      handleAddToProduct(products[0], typeOfAdd);
      setshowProductForm2(true);
    } else {
      setSelectedProduct(null);
    }
  };

  //cerrar dialogo de agregar servicio
  const closeDialog = () => {
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setVisible(false);
  };

  const closeDialogSubproducto = () => {
    setSelectedProduct(null);
    setshowProductForm2(false);
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setVisible(false);
  };
  //cambio de producto en dialogo de agregar servicio
  const handleProductChange = (e) => {
    setSelectedServicios([]);
    setRawServicios([]);
    setSelectedProduct(e.value);
    setshowProductForm2(false);
  };

  const handleshowProductForm2 = async () => {
    if (selectedProduct) {
      await handleAddToProduct(selectedProduct, typeOfAdd);
      setshowProductForm2(true);
    }
  };

  const handleAddToProduct = async (producto, typeOfAdd) => {
    await fetchAgregado(typeOfAdd, producto.id, producto.id_empresa);
  };

  const [filteredServicios, setFilteredServicios] = useState([]);
  const [rawServicios, setRawServicios] = useState([]);
  const [selectedServicios, setSelectedServicios] = useState([]);

  const handleServicioSelectionChange = (e) => {setSelectedServicios(e.value);};

  /**
   * Obtiene datos de servicios y subproductos para agregarlos a la cotización.
   * @param {string} typeOfAdd - Tipo de agregado (producto o servicio).
   * @param {number} idProducto - ID del producto relacionado (si aplica).
   * @param {number} idEmpresa - ID de la empresa a la que pertenecen los servicios/subproductos.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const fetchAgregado = async (typeOfAdd, idProducto, idEmpresa) => {
    try {
      setLoading(true); // Activa el estado de carga mientras se obtienen los datos
      let dataServicios = [];

      // Realiza la solicitud para obtener los servicios de la empresa
      dataServicios = await getServiciosByIdEmpresa(baseUrl, idEmpresa);

      // Si la respuesta contiene un array de servicios, se asigna correctamente
      if (Array.isArray(dataServicios.servicios)) {
        dataServicios = dataServicios.servicios;
      }

      // Almacena la lista completa de servicios obtenidos
      setRawServicios(dataServicios);

      // Filtra los servicios que están marcados como "incluidos"
      setFilteredServicios(
        dataServicios.filter((servicio) => servicio.incluido)
      );

      setLoading(false); // Desactiva el estado de carga tras completar la solicitud
    } catch (error) {
      console.error(error); // Captura y muestra en consola cualquier error
      setLoading(false); // Asegura que el indicador de carga se detenga en caso de error
    }
  };

  /**
   * Actualiza los detalles de un servicio para adaptarlo al formato de cotización.
   * @param {Object} service - Objeto representando el servicio a actualizar.
   * @param {Object} producto - Producto de la cotización al que se asocia el servicio.
   * @return {Object} Servicio actualizado con los valores necesarios.
   */
  const updateServiceDetails = (service, producto) => {
    // Encontrar el arriendo asociado
    const arriendoAsociado = flattenedDataArriendo.find(
      (item) => item.descripcion === producto.descripcion
    );

    return {
      ...service,
      relacion: "servicio",
      cobro: "Factura Afecta",
      desde: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.desde) : formatDateTramoSilencioso(desde),
      hasta: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.hasta) : formatDateTramoSilencioso(hasta),
      descuento: 0,
      tramo: null,
      tipo: "Adicional",
      contrato: true,
      consolidado: false,
      agrupamiento: 0,
      id_elemento: service.id,
      id: null,
      id_cotizacion: idCotizacion,
    };
  };

  /**
   * Maneja la adición de "Obra Civil" a la cotización si existe en los servicios.
   * @param {Array} servicesList - Lista de servicios.
   * @param {Object} producto - Producto de la cotización al que se asocia.
   * @return {Object|null} Objeto con la información de "Obra Civil" o null si no se encuentra.
   */
  const handleObraCivil = (servicesList, producto) => {
    const obraCivil = servicesList.find(
      (service) => service.descripcion === "Obra Civil"
    );

    if (obraCivil) {
      // Encontrar el arriendo asociado
      const arriendoAsociado = flattenedDataArriendo.find(
        (item) => item.descripcion === producto.descripcion
      );

      return {
        ...obraCivil,
        relacion: "servicio",
        tarifa_base: 0,
        tarifa_cliente: 0,
        tipo: "Adicional",
        desde: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.desde) : formatDateTramoSilencioso(desde),
        hasta: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.hasta) : formatDateTramoSilencioso(hasta),
        descripcion: `Obra Civil - ${producto.descripcion}`,
        codigo_producto: producto.codigo_producto,
      };
    }
    return null;
  };

  /**
   * Maneja la adición de "Habilitacion Fibra" a la cotización si existe en los servicios.
   * @param {Array} servicesList - Lista de servicios.
   * @param {Object} producto - Producto de la cotización al que se asocia.
   * @return {Object|null} Objeto con la información de "Habilitación Fibra" o null si no se encuentra.
   */
  const handleHabilitacionFibra = (servicesList, producto) => {
    const habilitacionFibra = servicesList.find(
      (service) => service.descripcion === "Habilitacion Fibra"
    );

    if (habilitacionFibra) {
      // Encontrar el arriendo asociado
      const arriendoAsociado = flattenedDataArriendo.find(
        (item) => item.descripcion === producto.descripcion
      );

      habilitacionFibra.relacion = "servicio";
      habilitacionFibra.tarifa_base = 0;
      habilitacionFibra.tarifa_cliente = 0;
      habilitacionFibra.descripcion = `Habilitacion Fibra - ${producto.descripcion}`;
      habilitacionFibra.desde = arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.desde) : formatDateTramoSilencioso(desde);
      habilitacionFibra.hasta = arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.hasta) : formatDateTramoSilencioso(hasta);
      habilitacionFibra.codigo_producto = producto.codigo_producto;
      return habilitacionFibra;
    }
    return null;
  };

  /**
   * Guarda un subproducto adicional en la cotización: inserta el detalle,
   * agrega "Obra Civil" si corresponde y refresca el detalle de la cotización.
   * @param {Object} nuevoSubproducto - Subproducto construido por FormAgregarSubproductoCotizacion.
   * @param {Object} producto - Producto de la cotización seleccionado en el diálogo.
   */
  const handleGuardarSubproductoDesdeDialog = async (nuevoSubproducto, producto) => {
    if (loading) return;
    if (guardandoRef.current) return;
    guardandoRef.current = true;
    setLoading(true);
    try {
      // Agrega "Obra Civil" solo para subproductos adicionales (incluido = 0)
      if (nuevoSubproducto.tipo !== "Incluido") {
        const descripcionObraCivil = `Obra Civil - ${producto.descripcion}`;
        const yaExisteObraCivil = serviciosUnicos.some(
          (item) => item.descripcion === descripcionObraCivil
        );

        if (!yaExisteObraCivil) {
          // Asegura la lista de servicios de la empresa (tipo_servicio)
          let serviciosEmpresa = rawServicios;
          if (
            !Array.isArray(serviciosEmpresa) ||
            serviciosEmpresa.length === 0
          ) {
            try {
              const dataServicios = await getServiciosByIdEmpresa(
                baseUrl,
                producto.id_empresa
              );
              serviciosEmpresa = Array.isArray(dataServicios.servicios)
                ? dataServicios.servicios
                : Array.isArray(dataServicios)
                ? dataServicios
                : [];
              setRawServicios(serviciosEmpresa);
            } catch (error) {
              console.error("Error al obtener servicios de la empresa:", error);
              serviciosEmpresa = [];
            }
          }

          const obraCivil = handleObraCivil(serviciosEmpresa || [], producto);
          if (obraCivil) {
            const newObra = updateServiceDetails(obraCivil, producto);
            serviciosUnicos.push(newObra);
          }
        }
      }

      // Envía los datos a la API: insert del subproducto + Obra Civil y updates
      // de servicios únicos, todo en una llamada transaccional
      const insertarItems = [{ ...nuevoSubproducto }, ...serviciosUnicos]
        .filter((item, index, arr) => item.id == null)
        .map((item) => toSyncItem(formatDatesIfNeeded(item, false), monedaOptions));
      const actualizarItems = serviciosUnicos
        .filter((item) => item.id != null)
        .map((item) => toSyncItem(formatDatesIfNeeded(item, false), monedaOptions));

      if (insertarItems.length > 0 || actualizarItems.length > 0) {
        await sincronizarDetallesCotizacion(baseUrl, {
          idCotizacion,
          desactivar: [],
          insertar: insertarItems,
          actualizar: actualizarItems,
        });
      }

      // Refresca el detalle de la cotización para visualizarlo en la tabla de arriendo
      await getDetalleData();

      alert("Subproducto agregado correctamente.");
      setShowSubproductoDialog(false);
    } catch (error) {
      console.error("Error al agregar subproducto:", error);
      alert(error.message || "Error al agregar el subproducto");
    } finally {
      guardandoRef.current = false;
      setLoading(false);
    }
  };

  /**
   * Maneja la adición de un servicio adicional a la cotización.
   * @param {string} typeOfAdd - Tipo de adición ("servicio").
   */
  const handleAñadirAdicional = async (typeOfAdd) => {
    setLoading(true);

    // Manejo de la adición de servicios adicionales
    // Encontrar el arriendo asociado
    const arriendoAsociado = flattenedDataArriendo.find(
      (item) => item.descripcion === selectedProduct.descripcion
    );

    const updatedServicios = selectedServicios.map((servicio) => ({
      ...servicio,
      descripcion: `${servicio.descripcion} - ${selectedProduct.descripcion}`,
      tarifa_cliente: servicio.tarifa_base,
      relacion: "servicio",
      desde: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.desde) : formatDateTramoSilencioso(desde),
      hasta: arriendoAsociado ? formatDateTramoSilencioso(arriendoAsociado.hasta) : formatDateTramoSilencioso(hasta),
      descuento: 0,
      tramo: null,
      tipo: "Adicional",
      cantidad: 0,
      cobro:
        ["Gasto Comun", "Agua", "Electricidad"].includes(servicio.descripcion)
          ? "Nota de Cobro"
          : "Factura Afecta",
      contrato: true,
      consolidado: false,
      agrupamiento: 0,
      id_elemento: servicio.id,
      id: null,
      id_cotizacion: idCotizacion,
      codigo_producto: selectedProduct.codigo_producto,
    }));

     // Verifica si los servicios ya están agregados (validación robusta por claves)
    const buildKey = (s) => `${s.id_elemento}|${s.codigo_producto || ""}`;
    const existingKeys = new Set((servicios || []).map(buildKey));

    const duplicateServicios = updatedServicios.filter((us) =>
      existingKeys.has(buildKey(us))
    );

    if (duplicateServicios.length > 0) {
      const duplicateDescriptions = duplicateServicios
        .map((servicio) => servicio.descripcion)
        .join(", ");
      alert(
        `El producto ya tiene estos servicios asociados: ${duplicateDescriptions}`
      );
      setLoading(false);
      return;
    }

    // Si hay servicios de "Internet", se añade "Habilitación Fibra"
    const hasInternet = updatedServicios.some((servicio) =>
      servicio.descripcion.includes("Internet")
    );

    if (hasInternet) {
      const habilitacionFibra =
        handleHabilitacionFibra(serviciosUnicos, selectedProduct) ||
        handleHabilitacionFibra(rawServicios, selectedProduct);

      if (
        habilitacionFibra &&
        !serviciosUnicos.some(
          (item) => item.descripcion === habilitacionFibra.descripcion
        )
      ) {
        const newHabilitacion = updateServiceDetails(habilitacionFibra, selectedProduct);
        serviciosUnicos.push(newHabilitacion);
      }
    }

    // Envía los datos a la API: servicios adicionales + servicios únicos nuevos,
    // todo en una llamada transaccional
    const insertarAdicionales = [...updatedServicios, ...serviciosUnicos]
      .filter((item) => item.id == null)
      .map((item) => toSyncItem(formatDatesIfNeeded(item, false), monedaOptions));
    const actualizarAdicionales = serviciosUnicos
      .filter((item) => item.id != null)
      .map((item) => toSyncItem(formatDatesIfNeeded(item, false), monedaOptions));

    if (insertarAdicionales.length > 0 || actualizarAdicionales.length > 0) {
      await sincronizarDetallesCotizacion(baseUrl, {
        idCotizacion,
        desactivar: [],
        insertar: insertarAdicionales,
        actualizar: actualizarAdicionales,
      });
    }
    await getDetalleData();

    setLoading(false);
    closeDialog(); // Cierra el cuadro de diálogo después de completar la acción
  };

  /**
   * Construye la URL para verificar si hay datos faltantes en la información del cliente.
   * @param {number} idCliente - ID del cliente a consultar.
   * @return {string} URL para obtener la información faltante del cliente.
   */

  /**
   * Valida que los productos y subproductos de la cotización sigan activos en
   * el catálogo antes de ejecutar acciones críticas (cerrar contrato, terminar,
   * rechazar). Bloquea el flujo mostrando el detalle de los inactivos.
   * @return {boolean} `true` si todos los elementos están activos.
   */
  const validarProductosActivos = async () => {
    try {
      const data = await validarElementosActivosCotizacion(baseUrl, idCotizacion);

      if (data?.ok === false && Array.isArray(data.inactivos) && data.inactivos.length > 0) {
        const descripciones = data.inactivos
          .map((item) => item.descripcion)
          .join(", ");
        toast.current.show({
          severity: "warn",
          summary: "Productos inactivos",
          detail: `Hay productos o subproductos inactivos en la cotización: ${descripciones}`,
          life: 8000,
        });
        alert(
          "No se puede continuar porque hay productos o subproductos inactivos en la cotización:\n\n" +
            descripciones +
            "\n\nDebe activarlos en el mantenedor o reemplazarlos antes de continuar."
        );
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error al validar productos activos:", error);
      alert("Error al validar los productos de la cotización");
      return false;
    }
  };

  /**
   * Consulta la configuración predeterminada de documentos de venta del
   * cliente para la empresa de la cotización (combinación cliente + empresa)
   * y sus asignaciones vigentes/futuras de ESA empresa antes de abrir el
   * diálogo de cierre. Si el cliente no tiene configuración, se establece
   * por defecto "separado" para todos los tipos del catálogo. La regla de
   * agrupación por empresa se aplica filtrando los existentes a la empresa
   * de la cotización. Si falla alguna consulta, el diálogo funciona igual
   * que siempre (config por defecto / sin existentes).
   */
  const abrirDialogoCerrarContrato = async () => {
    const idEmpresaCotizacion = Number(cotizacion?.id_empresa_arrendadora);
    const tieneIdEmpresa = Number.isFinite(idEmpresaCotizacion) && idEmpresaCotizacion > 0;

    if (tieneIdEmpresa) {
      try {
        const data = await getConfiguracionPredeterminada(
          baseUrl,
          idCliente,
          idEmpresaCotizacion
        );
        const configuracion =
          Array.isArray(data.configuracion) && data.configuracion.length > 0
            ? data.configuracion
            : null;
        // Sin configuración asignada: por defecto "separado" para cada tipo
        // del catálogo (respuesta esperada del backend ante clientes nuevos)
        setConfiguracionPredeterminada(
          configuracion
            ? configuracion
            : (Array.isArray(tiposDocumento) ? tiposDocumento : []).map(
                (tipo) => ({
                  codigo: tipo.codigo,
                  descripcion: tipo.descripcion,
                  consolidado: false,
                  cantidadDocumentos: null,
                })
              )
        );
      } catch (error) {
        console.error(
          "Error al consultar la configuración predeterminada del cliente:",
          error
        );
        setConfiguracionPredeterminada(null);
      }
    } else {
      // Sin empresa en la cotización: config por defecto ("separado")
      setConfiguracionPredeterminada(null);
    }

    try {
      const rutCliente = cliente?.rut ? String(cliente.rut).trim() : null;
      const dataAsig = await getConfiguracionDocumentos(
        baseUrl,
        rutCliente ? { rut: rutCliente } : {}
      );
      const clientes = Array.isArray(dataAsig.clientes) ? dataAsig.clientes : [];
      // El response agrupa por combinación (cliente, empresa): un cliente con
      // asignaciones en varias empresas aparece en varias entradas con el
      // mismo rut. Se reúnen las asignaciones de TODAS sus combinaciones
      // (match por id con fallback por rut) para luego filtrar por la empresa
      // de la cotización; antes un find devolvía solo la primera combinación
      // y si era otra empresa el módulo quedaba sin ítems vigentes/futuros
      let candidatos = clientes.filter(
        (c) => Number(c?.id) === Number(idCliente)
      );
      if (candidatos.length === 0 && rutCliente) {
        candidatos = clientes.filter(
          (c) => String(c.rut ?? "").trim() === rutCliente
        );
      }
      const todas = candidatos.flatMap((c) =>
        Array.isArray(c.asignaciones) ? c.asignaciones : []
      );
      // Regla de agrupación: solo asignaciones de la empresa de la cotización
      // (por id de empresa; fallback por nombre sin distinguir mayúsculas)
      const normEmpresa = (v) => String(v ?? "").trim().toLowerCase();
      const mismasEmpresas = todas.filter((a) => {
        if (tieneIdEmpresa && a.id_empresa != null) {
          return Number(a.id_empresa) === idEmpresaCotizacion;
        }
        if (cotizacion?.empresa && a.empresa) {
          return normEmpresa(a.empresa) === normEmpresa(cotizacion.empresa);
        }
        return false;
      });
      setAsignacionesVigentesFuturas(mismasEmpresas);
    } catch (error) {
      console.error(
        "Error al consultar las asignaciones vigentes/futuras del cliente:",
        error
      );
      setAsignacionesVigentesFuturas([]);
    }

    setShowCerrarContrato(true);
  };

  /**
   * Verifica si el cliente tiene información faltante antes de cerrar el contrato.
   * - Si falta información, redirige al usuario a completarla.
   * - Si no falta información, permite proceder con el cierre del contrato.
   */
  const checkDatosFaltantesCliente = async () => {
    try {
      setLoading(true);
      //await guardarCotizacion();

      // Valida que los productos y subproductos de la cotización estén activos
      if (!(await validarProductosActivos())) {
        return;
      }

      // Realiza la solicitud para obtener la información faltante del cliente
      const data = await getInformacionFaltanteByIdCliente(baseUrl, idCliente);

      // Si la respuesta indica que falta información
      if (data?.faltaInformacion && data.faltaInformacion.length > 0) {
        // Verifica si faltan datos específicos (contactos, representante legal, dirección)
        if (
          !shouldRenderContactos(data.faltaInformacion) &&
          !shouldRenderRepresentanteLegal(data.faltaInformacion) &&
          !shouldRenderDireccion(data.faltaInformacion)
        ) {
          // Si no faltan estos datos específicos, permite cerrar el contrato
          await abrirDialogoCerrarContrato();
        } else {
          // Si falta información importante, muestra una alerta y abre el diálogo
          alert("Falta información: Será redirigido para completar la información del cliente, una vez terminado puede volver a cerrar el contrato");
          setShowDialog(true);
        }
      } else {
        await abrirDialogoCerrarContrato();// Si no falta información, permite cerrar el contrato
      }
    } catch (error) {
      console.error("Error al verificar datos faltantes:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ha ocurrido un error al verificar los datos del cliente",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTerminar = async () => {
    setShowVencimientoDialog(true);
  };

  const handleRechazar = () => {
    setShowRechazarDialog(true);
  };

  const confirmarRechazo = async () => {
    if (!observacion.trim()) {
      alert("Por favor, ingrese el motivo del rechazo");
      return;
    }

    // Valida que los productos y subproductos de la cotización estén activos
    if (!(await validarProductosActivos())) {
      return;
    }

    try {
      setLoading(true);
      await guardarCotizacion();

      const cot = await getCotizacionById(baseUrl, idCotizacion);
      const fechaFormateada = moment(cot.vencimiento).format("YYYY-MM-DD");
      
      // Construir URL para rechazar cotización
      await updateCotizacion(baseUrl, {
        idCotizacion,
        idCliente,
        idEstado: 6, // Estado de la cotización a Revision
        idCreador: sessionStorage.getItem("usuario_id"), // ID del usuario que guarda la cotización
        desde,
        hasta,
        aviso: 0,
        observacion,
        vencimiento: fechaFormateada, // ← La fecha ya se está pasando aquí correctamente
      });
      
      alert("La cotización se ha rechazado correctamente");
      setLoading(false);
      setShowRechazarDialog(false);
      setObservacion("");
      navigate("/revision");
    } catch (error) {
      console.error("Error al rechazar", error);
      alert("Error al rechazar la cotización");
    } finally {
      setLoading(false);
    }
  };

  const cancelarRechazo = () => {
    setShowRechazarDialog(false);
    setObservacion("");
  };

  // Funciones para el diálogo de vencimiento
  const cancelarVencimiento = () => {
    setShowVencimientoDialog(false);
    setFechaVencimiento(null);
  };

  const confirmarVencimiento = async () => {
    if (!fechaVencimiento) {
      alert("Por favor, seleccione una fecha de vencimiento");
      return;
    }

    // Valida que los productos y subproductos de la cotización estén activos
    if (!(await validarProductosActivos())) {
      return;
    }

    try {
      // Formatear la fecha para enviarla al backend
      const fechaFormateada = moment(fechaVencimiento).format("YYYY-MM-DD");
      
      setShowVencimientoDialog(false);
      setLoading(true);
      
      await guardarCotizacion();
      
      await updateCotizacion(baseUrl, {
        idCotizacion,
        idCliente,
        idEstado: 3, // Estado de la cotización a Revision
        idCreador: sessionStorage.getItem("usuario_id"), // ID del usuario que guarda la cotización
        desde,
        hasta,
        aviso: 0,
        observacion: null, // Usar la observación existente en lugar de null
        vencimiento: fechaFormateada, // Usar la fecha de vencimiento seleccionada
      });

      setLoading(false);
      navigate("/revision", {
        state: {
          toast: {
            severity: 'success',
            summary: 'Éxito',
            detail: 'La cotización se ha guardado con éxito',
            life: 3000
          }
        }
      });
    } catch (error) {
      console.error("Error terminar", error);
      alert("Error al finalizar la cotización");
    } finally {
      setLoading(false);
    }
  };
  /**
   * Verifica si faltan datos de contacto en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato de contacto, `false` en caso contrario.
   */
  const shouldRenderContactos = (faltaInformacion) => {
    const fields = ["nombre_contacto","tipo_contacto","telefono_contacto","correo_contacto",];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos de contacto está en la lista de información faltante
  };

  /**
   * Verifica si faltan datos del representante legal en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato del representante legal, `false` en caso contrario.
   */
  const shouldRenderRepresentanteLegal = (faltaInformacion) => {
    const fields = ["rut_representante_legal","nombre_representante_legal","correo_representante_legal","telefono_representante_legal",];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos del representante legal está en la lista de información faltante
  };

  /**
   * Verifica si faltan datos de dirección en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato de dirección, `false` en caso contrario.
   */
  const shouldRenderDireccion = (faltaInformacion) => {
    const fields = ["direccion_domicilio", "tipo_domicilio"];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos de dirección está en la lista de información faltante
  };

  /**
   * Maneja la redirección del usuario para agregar un nuevo producto a la cotización.
   * - Muestra una confirmación antes de proceder.
   * - Redirige al usuario a la pantalla de selección de productos si confirma.
   */
  const handleAgregarProducto = () => {
    const userConfirmed = window.confirm("Serás redirigido para poder seleccionar un producto nuevo, asegúrate de guardar antes de salir de esta página.");

    if (userConfirmed) {
      // Obtiene los parámetros de la URL actual
      const searchParams = new URLSearchParams(location.search);
      const idCliente = parseInt(searchParams.get("idCliente"));
      const idCotizacion = parseInt(searchParams.get("idCotizacion"));

      const desdeParam = searchParams.get("desde");
      const desde = desdeParam || moment().add(1, "day").format("YYYY-MM-DD");
      const hasta = searchParams.get("hasta");

      // Redirige al usuario a la página para agregar un producto con los mismos parámetros
      navigate(`/agregarProducto?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desde}&hasta=${hasta}`);
    }
  };

  // ——————————————————————————————
  // BTN DESCARGAR PDF
  // ——————————————————————————————
  const handleDescargarPdf = async () => {
    if (exportandoPdf) return;
    try {
      setExportandoPdf(true);
      await exportarCotizacionAPdf({
        idCotizacion,
        cotizacion,
        cliente,
        productos: [
          ...new Set(
            carro
              .filter((item) => item.relacion === "producto")
              .map((item) => item.descripcion)
          ),
        ],
        arriendos: flattenedDataArriendo,
        servicios,
        serviciosUnicos,
        subtotalArriendo,
        subtotalServicios,
        monedaOptions,
      });
    } catch (error) {
      console.error("Error al generar el PDF de la cotización:", error);
      alert("Ocurrió un error al generar el PDF de la cotización");
    } finally {
      setExportandoPdf(false);
    }
  };

  /**
   * Obtiene los datos de un cliente según su ID.
   * - Realiza una solicitud a la API para recuperar la información del cliente.
   * - Si la respuesta es exitosa, actualiza el estado con los datos del cliente.
   * - En caso de error, muestra el error en la consola.
   */
  // Referencia para el overlay (posiblemente un modal o una ventana emergente)
  const overlayRef = useRef(null);
  /**
   * Maneja la modificación de la asignación de una cotización.
   * - Muestra una confirmación antes de proceder.
   * - Si el usuario confirma, realiza una solicitud para cambiar el estado de la asignación.
   * - Si la solicitud es exitosa, recarga la página para reflejar los cambios.
   * - En caso de error, muestra un mensaje en la alerta y en la consola.
   */

  // ——————————————————————————————
  // BTN MODIFICAR ASIGNACION
  // ——————————————————————————————
  const handleShowModificarAsignacion = async () => {
    // Muestra una confirmación al usuario antes de proceder con la modificación
    const confirm = window.confirm(
      "¿Estás seguro de que deseas modificar la asignación?\n" +
      "\n" +
      "Al continuar, la asignación actual se marcará como anulada y se enviará a la lista de recotizaciones.\n" +
      "Se creará un folio hijo a partir de esta asignación, el cual se enviará a cotización para que puedas realizar las modificaciones necesarias."
    );

    if (confirm) {
      setLoading(true);
      try {
        // Obtiene el ID del usuario desde sessionStorage
        const idCreador = sessionStorage.getItem("usuario_id");

        // Si no hay un usuario identificado, lanza un error
        if (!idCreador) {
          throw new Error("Usuario no identificado. Inicia sesión para continuar.");
        }

        const result = await recotizar(baseUrl, idCotizacion, idCreador);

        // Si la respuesta es positiva, muestra una alerta de éxito y recarga la página
        if (result.respuesta) {
          alert("La asignación pasará a estado de recotización y podrá ser modificada.");
          setLoading(false);
          
          // Usa el nuevo idCotizacion si viene en la respuesta, si no, usa el actual
          const newIdCotizacion = result.idCotizacionHijo || idCotizacion;
          const baseUrl = window.location.href.split("/#/")[0];
          const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${newIdCotizacion}&desde=${desde}&hasta=${hasta}`;
          const fullUrl = `${baseUrl}/#${urlAVolver}`;
          window.location.href = fullUrl;
          window.location.reload();
          
        } else {
          // Si hay un error en la respuesta, lo muestra en una alerta
          setLoading(false);
          alert(`Error: ${result.mensaje}`);
        }
      } catch (error) {
        // Captura errores y los muestra en la consola y en una alerta
        setLoading(false);
        console.error("Error in handleShowModificarAsignacion:", error);
        alert(`Error: ${error.message}`);
      }
    }
  };

    // ——————————————————————————————
  // BTN RENOVAR ASIGNACION
  // ——————————————————————————————
  const handleShowRenovarAsignacion = () => {
    const confirm = window.confirm(
      "¿Estás seguro de que deseas renovar la asignación?\n" +
      "\n" +
      "Esta acción creará una nueva cotización basada en la asignación actual y comenzará a regir desde la fecha de término de la asignación vigente."
    );
    if (confirm) {
      setShowRenovarDialog(true);
    }else{
      return;
    }
  };

  const cancelarRenovacion = () => {
    setShowRenovarDialog(false);
    setHastaRenovacion(null);
  };

  const columnBodyTemplate = (rowData, column) => {
    const value = rowData[column.field];
    if (!value) return ""; // Si está vacío o null
    const number = parseFloat(value.replace(",", "."));
    return isNaN(number) ? value : `${number.toFixed(2)} UF`;
  };

  return (
    <div className="card">
      <>
        <Toast ref={toast} />
        
        <OverlayPanel ref={overlayRef} className="p-4">
          <h5 className="text-sm font-semibold text-gray-700 mb-2">
            Información del Cliente
          </h5>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>
              <strong>RUT:</strong> {cliente?.rut}
            </li>
            <li>
              <strong>Razón Social:</strong> {cliente?.razon_social || "—"}
            </li>
            <li>
              <strong>Alias:</strong> {cliente?.alias}
            </li>
            <li>
              <strong>Activo:</strong> {cliente?.activo ? "Sí" : "No"}
            </li>
          </ul>
          <h6 className="text-sm font-semibold text-gray-700 mt-3">
            Contactos:
          </h6>
          <ul className="text-sm text-gray-600 space-y-1">
            {(cliente?.contactos || []).map((contacto) => (
              <li key={contacto?.id}>
                <strong>{contacto?.nombre}:</strong>{" "}
                {contacto?.correo || "Sin correo"}
              </li>
            ))}
          </ul>
        </OverlayPanel>

        {/* BOTÓN DESCARGAR PDF (fuera del área de captura) */}
        <div className="flex justify-content-end mb-2">
          <Button
            label="Descargar PDF"
            icon="pi pi-file-pdf"
            className="p-button-primary p-button-rounded"
            onClick={handleDescargarPdf}
            loading={exportandoPdf}
            raised
          />
        </div>

        {/* ÁREA DE CAPTURA PARA EL PDF: cabecera + tablas */}
        <div id="cotizacion-pdf-content">
        <div className="p-4 bg-white shadow-md rounded-lg max-h- overflow-y-auto">
          {cotizacion?.folio ? (
            <>
              <h2 className="text-xl font-semibold text-gray-900">
                Asignación Folio: {cotizacion.folio}
              </h2>
              <h5 className="text-sm font-normal text-gray-600 mt-1">
                Cotización N°: {idCotizacion}
              </h5>
            </>
          ) : (
            <h2 className="text-xl font-semibold text-gray-900">
              Cotización: {idCotizacion}
            </h2>
          )}

          <div className="flex flex-row gap-2">
            <h5 className="text-base font-medium text-gray-800">
              Cliente:{" "}
              <span
                className="text-blue-500 ml-1 cursor-pointer hover:underline"
                onClick={(e) => overlayRef.current.toggle(e)}
              >
                {cliente?.razon_social?.toUpperCase() || ""}
              </span>
            </h5>
          </div>

          {/* Products List */}
          <div>
            <div className="flex flex-wrap gap-2">
              <h5 className="text-base font-medium text-gray-800">
                Productos:{" "}
                <span className="text-gray-700">
                  {[
                    ...new Set(
                      carro
                        .filter((item) => item.relacion === "producto")
                        .map((item) => item.descripcion)
                    ),
                  ].join(" | ")}
                </span>
              </h5>
            </div>
          </div>
          <div>
            <div className="flex flex-wrap gap-2">
              <h5 className="text-base font-medium text-gray-800">
                Empresa Arrendadora:{" "}
                <span className="ml-1">{cotizacion?.empresa}</span>
              </h5>
            </div>
          </div>
          {/* <div>
            <div className="flex flex-wrap gap-2">
              <h5 className="text-base font-medium text-gray-800">
                Valor Uf :{" "}
                <span className="ml-1">{valorUf}</span>
              </h5>
            </div>
          </div> */}

          {cotizacion?.estado?.estado === "ASIGNACIÓN" && (
            <div>
              <div className="flex flex-wrap gap-2">
                <h5 className="text-base font-medium text-gray-800">
                  Estado:{" "}
                  <span className="ml-1">{cotizacion?.estado?.estado}</span>
                </h5>
              </div>
            </div>
          )}
        </div>

              <ArriendoDataTable
                flattenedDataArriendo={flattenedDataArriendo}
                setFlattenedDataArriendo={setFlattenedDataArriendo}
                loading={loading}
                cotizacion={cotizacion}
                desde={desde}
                hasta={hasta}
                idCotizacion={idCotizacion}
                idCliente={idCliente}
                servicios={servicios}
                setServicios={setServicios}
                setDesde={setDesde}
                setHasta={setHasta}
                setLoading={setLoading}
                handleTablaChange={handleTablaChange}
                postUpdateDataCotizacion={postUpdateDataCotizacion}
                updateCotizacion={updateCotizacion}
                handleNewTramoArriendo={handleNewTramoArriendo}
                handleBorrarLinea={handleBorrarLinea}
                // handleMaskChange={handleMaskChange}
                empresas={empresas}
                handleTramoConfirmationArriendo={handleTramoConfirmationArriendo}
                showProductForm2={showProductForm2}
                setshowProductForm2={setshowProductForm2}
                handleProductChange={handleProductChange}
                handleshowProductForm2={handleshowProductForm2}
                handleAddToProduct={handleAddToProduct}
                cobroOptions={cobroOptions}
                monedaOptions={monedaOptions}
                subtotalArriendo={subtotalArriendo}
                products={products}
                showTramoModalArriendo={showTramoModalArriendo}
                setShowTramoModalArriendo={setShowTramoModalArriendo}
                nombreCuadro={nombreCuadro}
                setNombreCuadro={setNombreCuadro}
                tramos={tramos}
                tramoCounter={tramoCounter}
                selectFechaTramo={selectFechaTramo}
                dateFormats={dateFormats}
              />

              {servicios.length > 0 && (
                <ServiciosDataTable
                  servicios={servicios}
                  loading={loading}
                  cotizacion={cotizacion}
                  desde={desde}
                  hasta={hasta}
                  idCotizacion={idCotizacion}
                  idCliente={idCliente}
                  flattenedDataArriendo={flattenedDataArriendo}
                  setLoading={setLoading}
                  setDesde={setDesde}
                  setHasta={setHasta}
                  handleTablaChange={handleTablaChange}
                  postUpdateDataCotizacion={postUpdateDataCotizacion}
                  updateCotizacion={updateCotizacion}
                  //handleMaskChange={handleMaskChange}
                  handleNewTramoServicio={handleNewTramoServicio}
                  handleBorrarLinea={handleBorrarLinea}
                  cobroOptions={cobroOptions}
                  monedaOptions={monedaOptions}
                  handleTramoConfirmationServicio={handleTramoConfirmationServicio}
                  showTramoModalServicio={showTramoModalServicio}
                  setShowTramoModalServicio={setShowTramoModalServicio}
                  nombreCuadro={nombreCuadro}
                  setNombreCuadro={setNombreCuadro}
                  tramos={tramos}
                  tramoCounter={tramoCounter}
                  selectFechaTramo={selectFechaTramo}
                  subtotalServicios={subtotalServicios}
                />
              )}

              {serviciosUnicos.length > 0 && (
                <ServiciosUnicosDataTable
                  serviciosUnicos={serviciosUnicos}
                  loading={loading}
                  cotizacion={cotizacion}
                  handleTablaChange={handleTablaChange}
                  //handleMaskChange={handleMaskChange}
                  handleNewTramoCuota={handleNewTramoCuota}
                  handleBorrarLinea={handleBorrarLinea}
                  handleTramoConfirmacionCuota={handleTramoConfirmacionCuota}
                  cobroOptions={cobroOptions}
                  monedaOptions={monedaOptions}
                  showTramoModalUnico={showTramoModalUnico}
                  setShowTramoModalUnico={setShowTramoModalUnico}
                  nombreCuadro={nombreCuadro}
                  cuotas={cuotas}
                  setCuotas={setCuotas}
                  maxAmountOfCuotas={maxAmountOfCuotas}
                  itemCuotas={itemCuotas}
                />
              )}
        </div>

              {/* BOTONES */}
              <CotizacionActions
                cotizacion={cotizacion}
                loading={loading}
                loadingAsig={loadingAsig}
                handleAgregarProducto={handleAgregarProducto}
                openDialog={openDialog}
                handleShowResumenMensual={handleShowResumenMensual}
                guardarCotizacion={guardarCotizacion}
                checkDatosFaltantesCliente={checkDatosFaltantesCliente}
                handleTerminar={handleTerminar}
                handleRechazar = {handleRechazar}
                cerrarContrato={cerrarContrato}
                diasAviso={diasAviso}
                setDiasAviso={setDiasAviso}
                cantidadDiasAvisoContrato={cantidadDiasAvisoContrato}
                diasFirma={diasFirma}
                setDiasFirma={setDiasFirma}
                cantidadDiasFirmaContrato={cantidadDiasFirmaContrato}
                showCerrarContrato={showCerrarContrato}
                setShowCerrarContrato={setShowCerrarContrato}
                idCliente={idCliente}
                idEmpresa={cotizacion?.id_empresa_arrendadora}
                configuracionPredeterminada={configuracionPredeterminada}
                asignacionesVigentesFuturas={asignacionesVigentesFuturas}
                catalogo={tiposDocumento}
                handleShowModificarAsignacion={handleShowModificarAsignacion}
                handleShowRenovarAsignacion={handleShowRenovarAsignacion}
                detallesCobro={detallesCobro}
                setDetallesCobro={setDetallesCobro}
                handleTablaChange={handleTablaChange}
                flattenedDataArriendo={flattenedDataArriendo}
                servicios = {servicios}
                serviciosUnicos = {serviciosUnicos}
                setFlattenedDataArriendo={setFlattenedDataArriendo}
                setServicios={setServicios}
                setServiciosUnicos={setServiciosUnicos}
              />
  
        {/* FOOTER */}
        {/* <div className="col-12 md:col-12">
          <Panel header="TOTAL">
            <div className="grid text-right">
              <div className="col-10">SUBTOTAL</div>
              <div className="col-2">
                <span className="pink-color">
                  {subtotal.toLocaleString("en-US").replace(".", ",")} UF
                </span>
              </div>

              <div className="col-10">
                <span>I.V.A</span>
              </div>
              <div className="col-2">
                <span className="pink-color">
                  {iva.toLocaleString("en-US").replace(".", ",")} UF
                </span>
              </div>

              <div className="col-10">
                <span>TOTAL</span>
              </div>
              <div className="col-2">
                <span className="pink-color">
                  {total.toLocaleString("en-US").replace(".", ",")} UF
                </span>
              </div>
              <div className="col-10">
                <span></span>
              </div>

              
            </div>
          </Panel> 
          
        </div>*/}

        <ResumenMensualDialog
          visible={verResumenMensual}
          onHide={() => setVerResumenMensual(false)}
          loading={loading}
          matrixArray={matrixArray}
          columns={columns}
          columnBodyTemplate={columnBodyTemplate}
        />

        <Dialog
          visible={showDialog}
          onHide={() => setShowDialog(false)}
          style={{ width: "85vw" }}
          closable={true}
          modal
        >
          <FormCrearCliente
            modoEdicion={true}
            clienteData={cliente}
            onSuccess={() => {
              toast.current.show({
                severity: "success",
                summary: "Operación Exitosa",
                detail: "El cliente ha sido guardado correctamente.",
                life: 3000,
              });
              // Re-ejecuta getClienteById para actualizar la data del cliente
              fetchDataCliente();
              setShowDialog(false);
            }}
            onError={(error) => {
              console.error("Error:", error);
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "No se pudo actualizar el cliente. Por favor, intente nuevamente.",
                life: 3000,
              });
            }}
            onClose={() => {
              window.location.reload();
              setShowDialog(false);
            }}
          />
        </Dialog>

        <Dialog
          header="Agregar Adicional"
          visible={visible}
          modal
          onHide={closeDialogSubproducto}
          className="p-fluid product-dialog"
        >
          <div>
            <h6 className="mb-3">
                Información del Producto
            </h6>    
            <span className="p-float-label mt-2 mb-3">
              <Dropdown
                value={selectedProduct}
                options={products}
                onChange={handleProductChange}
                optionLabel="descripcion"
                placeholder="Seleccione un producto"
                className="w-full"
              />
              <label htmlFor="tipoSubP">Producto</label>
            </span>

            {selectedProduct && !showProductForm2 && (
              <div className="flex justify-content-center mt-4 mb-3">
                <Button
                  icon="pi pi-arrow-right"
                  label="Continuar"
                  className="p-button-rounded p-button-primary"
                  onClick={handleshowProductForm2}
                  style={{ width: "400px" }}
                  raised
                />
              </div>
            )}

            {showProductForm2 && typeOfAdd === "servicio" && (
              <>
                <DataTable
                  value={filteredServicios}
                  selection={selectedServicios}
                  onSelectionChange={handleServicioSelectionChange}
                  className="p-datatable-gridlines"
                  showGridlines
                  dataKey="id"
                  emptyMessage="No tiene servicios asociados"
                  loading={loading}
                >
                  <Column selectionMode="multiple" style={{ width: "3em" }} />
                  <Column field="descripcion" header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <i className="pi pi-list" style={{ color: '#2196F3' }}></i>
                      Servicios
                    </div>
                  } />
                  <Column field="moneda" header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <i className="pi pi-dollar" style={{ color: '#4CAF50' }}></i>
                      Moneda
                    </div>
                  } />
                  <Column field="unidad" header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <i className="pi pi-chart-bar" style={{ color: '#FF9800' }}></i>
                      Unidad Medida
                    </div>
                  } />
                </DataTable>

                <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    label="Agregar"
                    icon="pi pi-plus"
                    onClick={() => handleAñadirAdicional(typeOfAdd)}
                    className="p-button-rounded p-button-success p-button mb-2 mt-2"
                    disabled={selectedServicios.length === 0||loading}
                    style={{ width: "400px" }}
                    raised
                  />
                </div>
              </>
            )}
          </div>
        </Dialog>

        <FormAgregarSubproductoCotizacion
          visible={showSubproductoDialog}
          onHide={() => setShowSubproductoDialog(false)}
          products={products}
          baseUrl={baseUrl}
          idCotizacion={idCotizacion}
          desde={desde}
          hasta={hasta}
          detallesExistentes={flattenedDataArriendo}
          loading={loading}
          onGuardar={handleGuardarSubproductoDesdeDialog}
        />

        {/* Diálogo para motivo de rechazo */}
        <Dialog
          header="Motivo del Rechazo"
          visible={showRechazarDialog}
          style={{ width: '450px' }}
          modal
          onHide={cancelarRechazo}
          footer={
            <div>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button p-button-rounded p-button-outlined"
                onClick={cancelarRechazo}
              />
              <Button
                label="Confirmar Rechazo"
                icon="pi pi-check"
                className="p-button-primary p-button-rounded p-button"
                onClick={confirmarRechazo}
                disabled={loading}
                raised
              />
            </div>
          }
        >
          <div className="p-fluid">
            <label htmlFor="observacion">Seleccione el motivo del rechazo:</label>
            <Dropdown
              id="observacion"
              value={observacion}
              options={motivosRechazo}
              onChange={(e) => setObservacion(e.value)}
              optionLabel="label"
              placeholder="Seleccione un motivo de rechazo..."
              className="w-full"
              required
            />
          </div>
        </Dialog>

        {/* Diálogo para seleccionar la fecha de vencimiento */}
        <Dialog
          header={`Vencimiento de la Cotización N°${idCotizacion}`}
          visible={showVencimientoDialog}
          style={{ width: '450px' }}
          modal
          onHide={cancelarVencimiento}
          footer={
            <div>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button p-button-rounded p-button-outlined"
                onClick={cancelarVencimiento}
              />
              <Button
                label="Confirmar"
                icon="pi pi-check"
                className="p-button-success p-button-rounded p-button"
                onClick={confirmarVencimiento}
                disabled={loading || !fechaVencimiento}
                raised
              />
            </div>
          }
        >
          <span className="p-float-label mt-1">
            <Calendar
              id="fechaVencimiento"
              value={fechaVencimiento}
              onChange={(e) => setFechaVencimiento(e.value)}
              dateFormat="dd/mm/yy"
              placeholder="Seleccione"
              required
              minDate={new Date()}
              className="p-input-lg w-full"
              width="10px"
            />
            <label htmlFor="fechaVencimiento"><i className="pi pi-calendar"></i>  Fecha de Vencimiento:</label>
          </span>
        </Dialog>
        {/* Diálogo para renovar la asignación */}
        <RenovarAsignacionDialog visible={showRenovarDialog} onHide={cancelarRenovacion} idCotizacion={idCotizacion} idCliente={idCliente} desde={desde} hasta={hasta} motivosOptions={motivosRenovacion} />
      </>
    </div>
  );
};

export default RevisarCotizacion;